import {
  utils,
} from '@ama-sdk/core';
import {
  OrderReply,
} from '@dapi/sdk';
import {
  createAmount,
  createBound,
  createFlightItem,
  createMultiCurrencyAirPricingRecords,
  createMultiCurrencyUnitPrice,
  createName,
  createOrder,
  createOrderAirItem,
  createOrderEligibilities,
  createPaymentCard,
  createPaymentRecord,
  createTraveler,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  acknowledgeMock,
  cancelAndRefundMock,
  cancelMock,
  changeMock,
  CHARLES_DE_GAULLE,
  contacts,
  COTE_D_AZUR,
  flightReaccommodationMock,
  JOHN_F_KENNEDY_INTL,
} from '../dictionaries/index';
import {
  taxTemplate,
} from './mock-tax';

/* Mocks with Order with only the disrupted Oneway */
export const retrieveOrderMockDisruptedOneway = {
  warnings: [
    {
      code: '65227',
      title: 'FLIGHT DISRUPTION HAS OCCURRED: CHECK THE ORDER CONTENT'
    }
  ],
  data: {
    id: 'TBEVQ7',
    creationPointOfSale: {
      pointOfSaleId: 'HELAY08MO',
      countryCode: 'FI'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('11:09', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('11:35', -1)),
    isGroupBooking: false,
    air: {
      bounds: [
        {
          airBoundId: '15d58dd5ce4',
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          flights: [
            {
              id: 'ST3',
              cabin: 'eco',
              bookingClass: 'Y',
              statusCode: 'TK'
            }
          ],
          duration: 2400,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST1',
                cabin: 'eco',
                bookingClass: 'Y',
                statusCode: 'UN'
              }
            ],
            departure: {
              locationCode: 'HEL',
              sameAirport: true,
              sameCity: true,
              sameDay: false,
              deltaTime: -51_000
            },
            arrival: {
              locationCode: 'TKU',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: -50_700
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 0
            },
            duration: 2100
          }
        }
      ]
    },
    travelers: [
      {
        id: 'PT1',
        names: [
          {
            firstName: 'Tony',
            lastName: 'Perry',
            nameType: 'universal'
          }
        ]
      },
      {
        passengerTypeCode: 'CHD',
        id: 'PT2',
        names: [
          {
            firstName: 'Bobby',
            lastName: 'Perry',
            nameType: 'universal'
          }
        ],
        dateOfBirth: '2016-04-05'
      }
    ],
    contacts: [
      {
        id: 'OT6',
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: '7418529630',
        countryPhoneExtension: '+91'
      }
    ],
    travelDocuments: [
      {
        flightIds: ['ST2', 'ST3'],
        travelerIds: ['PT1'],
        id: '1052467303580',
        documentType: 'eticket',
        price: {
          base: 48_400,
          total: 65_948,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 8600,
              currencyCode: 'EUR',
              code: 'YR'
            },
            {
              value: 976,
              currencyCode: 'EUR',
              code: 'DQ'
            },
            {
              value: 1776,
              currencyCode: 'EUR',
              code: 'QU'
            },
            {
              value: 200,
              currencyCode: 'EUR',
              code: 'XU'
            },
            {
              value: 5996,
              currencyCode: 'EUR',
              code: 'YF'
            }
          ],
          totalTaxes: 17_548
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YPR0FI',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '229',
              departure: {
                locationCode: 'HEL',
                dateTime: new utils.DateTime(todayPlusNdays('23:45', 1))
              },
              arrival: {
                locationCode: 'TKU'
              }
            }
          },
          {
            fareClass: 'YPR0FI',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '230',
              departure: {
                locationCode: 'TKU',
                dateTime: new utils.DateTime(todayPlusNdays('06:15', 1))
              },
              arrival: {
                locationCode: 'HEL'
              }
            }
          }
        ]
      },
      {
        flightIds: ['ST2', 'ST3'],
        travelerIds: ['PT2'],
        id: '1052467303579',
        documentType: 'eticket',
        price: {
          base: 36_300,
          total: 52_638,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 8600,
              currencyCode: 'EUR',
              code: 'YR'
            },
            {
              value: 976,
              currencyCode: 'EUR',
              code: 'DQ'
            },
            {
              value: 1776,
              currencyCode: 'EUR',
              code: 'QU'
            },
            {
              value: 200,
              currencyCode: 'EUR',
              code: 'XU'
            },
            {
              value: 4786,
              currencyCode: 'EUR',
              code: 'YF'
            }
          ],
          totalTaxes: 16_338
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YPR0FI/CH',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '229',
              departure: {
                locationCode: 'HEL',
                dateTime: new utils.DateTime(todayPlusNdays('23:45', 1))
              },
              arrival: {
                locationCode: 'TKU'
              }
            }
          },
          {
            fareClass: 'YPR0FI/CH',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '230',
              departure: {
                locationCode: 'TKU',
                dateTime: new utils.DateTime(todayPlusNdays('06:15', 1))
              },
              arrival: {
                locationCode: 'HEL'
              }
            }
          }
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT3',
        code: 'CHLD',
        airlineCode: 'AY',
        statusCode: 'HK',
        quantity: 1,
        freetext: '05APR16',
        travelerIds: ['PT2']
      }
    ],
    paymentRecords: [
      {
        id: 'FPT15',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            },
            amount: {
              value: 65_948,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: ['PT1'],
        flightIds: ['ST2']
      },
      {
        id: 'FPT17',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            },
            amount: {
              value: 52_638,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: ['PT2'],
        flightIds: ['ST2']
      }
    ],
    orderEligibilities: {
      change: [
        {
          flightIds: ['ST3'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST1'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST2'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        }
      ],
      cancel: {
        isEligible: false
      },
      flightReaccommodation: {
        acknowledge: [
          {
            airBoundId: '15d58dd5ce4',
            isEligible: true,
            nonEligibilityReason: 'notActivated'
          }
        ],
        change: [
          {
            airBoundId: '15d58dd5ce4',
            isEligible: true
          }
        ]
      }
    }
  },
  dictionaries: {
    location: {
      HEL: {
        type: 'airport',
        airportName: 'HELSINKI VANTAA',
        cityCode: 'HEL',
        cityName: 'HELSINKI',
        countryCode: 'FI',
        timeZone: 'UTC+0200'
      },
      TKU: {
        type: 'airport',
        airportName: 'TURKU',
        cityCode: 'TKU',
        cityName: 'TURKU',
        countryCode: 'FI',
        timeZone: 'UTC+0200'
      }
    },
    country: {
      FI: 'FINLAND'
    },
    airline: {
      AY: 'FINNAIR'
    },
    aircraft: {
      AT7: 'AEROSPATIALE/ALENIA ATR 72'
    },
    flight: {
      ST2: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '230',
        departure: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('06:15', 6)),
          terminal: '1'
        },
        arrival: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('06:50', 6)),
          terminal: '2'
        },
        aircraftCode: 'AT7',
        duration: 2100,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      },
      ST1: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '223',
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('13:55', 1)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('14:30', 1)),
          terminal: '1'
        },
        aircraftCode: 'AT7',
        duration: 2100,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      },
      ST3: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '229',
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('23:45', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('00:25', 1)),
          terminal: '1'
        },
        aircraftCode: 'AT7',
        duration: 2400,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      }
    },
    tax: {
      QU: 'QU',
      YR: 'YR',
      DQ: 'DQ',
      XU: 'XU',
      YF: 'YF'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    specialServiceRequest: {
      CHLD: {
        name: 'CHILD PASSENGER INFORMATION'
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      },
      TK: {
        name: 'Confirmed, timechange'
      },
      UN: {
        name: 'Unable, does not operate'
      }
    },
    meal: {
      N: 'NO MEAL SERVICE'
    }
  }
};

export const retrieveOrderSwitchedMockDisruptedMultiBounds = {
  data: {
    id: '3I9EU7',
    creationPointOfSale: {
      pointOfSaleId: 'BOGAV08AB',
      countryCode: 'CO'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('10:44', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('13:10', -1)),
    isGroupBooking: false,
    air: {
      prices: {
        unitPrices: [
          {
            travelerIds: [
              'PT1'
            ],
            prices: [
              {
                base: {
                  value: 2_919_800,
                  currencyCode: 'COP'
                },
                total: {
                  value: 3_359_300,
                  currencyCode: 'COP'
                },
                taxes: [
                  {
                    value: 73_000,
                    currencyCode: 'COP',
                    code: 'YSTR'
                  },
                  {
                    value: 138_400,
                    currencyCode: 'COP',
                    code: 'COAE'
                  },
                  {
                    value: 92_600,
                    currencyCode: 'COP',
                    code: 'DGVZ'
                  },
                  {
                    value: 76_600,
                    currencyCode: 'COP',
                    code: 'IFDP'
                  },
                  {
                    value: 34_600,
                    currencyCode: 'COP',
                    code: 'IGEA'
                  },
                  {
                    value: 24_300,
                    currencyCode: 'COP',
                    code: 'IMEB'
                  }
                ],
                totalTaxes: {
                  value: 439_500,
                  currencyCode: 'COP'
                }
              }
            ]
          }
        ],
        totalPrices: [
          {
            base: {
              value: 2_919_800,
              currencyCode: 'COP'
            },
            total: {
              value: 3_359_300,
              currencyCode: 'COP'
            },
            totalTaxes: {
              value: 439_500,
              currencyCode: 'COP'
            }
          }
        ]
      },
      bounds: [
        {
          airBoundId: '1',
          originLocationCode: 'SAL',
          destinationLocationCode: 'BOG',
          flights: [
            {
              id: 'ST4',
              cabin: 'eco',
              bookingClass: 'V',
              statusCode: 'HK',
              fareFamilyCode: 'S'
            }
          ],
          duration: 10_800
        },
        {
          airBoundId: '1e74889e439',
          originLocationCode: 'BOG',
          destinationLocationCode: 'SAL',
          flights: [
            {
              id: 'ST5',
              cabin: 'eco',
              bookingClass: 'V',
              statusCode: 'HK'
            }
          ],
          duration: 11_100,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST3'
              }
            ],
            departure: {
              locationCode: 'BOG',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 41_700
            },
            arrival: {
              locationCode: 'SAL',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 41_700
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 0
            },
            duration: 11_100
          }
        }
      ],
      freeCheckedBaggageAllowanceItems: [
        {
          details: {
            type: 'piece',
            quantity: 0
          },
          flightIds: [
            'ST4'
          ],
          travelerIds: [
            'PT1'
          ]
        }
      ]
    },
    travelers: [
      {
        passengerTypeCode: 'ADT',
        id: 'PT1',
        names: [
          {
            firstName: 'Youssef',
            lastName: 'Srtst',
            nameType: 'universal',
            isPreferred: true
          }
        ]
      }
    ],
    contacts: [
      {
        id: 'OT6',
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: '12345'
      }
    ],
    travelDocuments: [
      {
        flightIds: [
          'ST4',
          'ST5'
        ],
        travelerIds: [
          'PT1'
        ],
        id: '1342496683356',
        documentType: 'eticket',
        price: {
          base: 2_919_800,
          total: 3_359_300,
          currencyCode: 'COP',
          taxes: [
            {
              value: 73_000,
              currencyCode: 'COP',
              code: 'YS'
            },
            {
              value: 138_400,
              currencyCode: 'COP',
              code: 'CO'
            },
            {
              value: 92_600,
              currencyCode: 'COP',
              code: 'DG'
            },
            {
              value: 76_600,
              currencyCode: 'COP',
              code: 'IF'
            },
            {
              value: 34_600,
              currencyCode: 'COP',
              code: 'IG'
            },
            {
              value: 24_300,
              currencyCode: 'COP',
              code: 'IM'
            }
          ],
          totalTaxes: 439_500
        },
        fareInfos: [
          {
            fareClass: 'VEOB1BRB',
            fareFamilyCode: 'S',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AV',
              marketingFlightNumber: '382',
              departure: {
                locationCode: 'BOG',
                dateTime: new utils.DateTime(todayPlusNdays('16:20', 0))
              },
              arrival: {
                locationCode: 'SAL'
              }
            }
          },
          {
            fareClass: 'VEOB1BRB',
            fareFamilyCode: 'S',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AV',
              marketingFlightNumber: '95',
              departure: {
                locationCode: 'SAL',
                dateTime: new utils.DateTime(todayPlusNdays('15:30', 0))
              },
              arrival: {
                locationCode: 'BOG'
              }
            }
          }
        ]
      }
    ],
    specialKeywords: [
      {
        id: 'OT41',
        keyword: 'ACKD',
        airlineCode: '1A',
        freetext: 'ACKNOWLEDGED BY USER AT 2021-01-18T11:26:13.894Z',
        flightIds: [
          'ST5'
        ]
      },
      {
        id: 'OT42',
        keyword: 'CEID',
        airlineCode: 'AV',
        statusCode: 'HK',
        quantity: 1,
        freetext: '2D9YPA5223HG5KGM84HAHCIWA',
        travelerIds: [
          'PT1'
        ]
      }
    ],
    orderEligibilities: {
      acknowledge: [
        {
          airBoundId: '2',
          disruption: {
            isEligible: false,
            nonEligibilityReasons: [
              {
                code: '50006',
                title: 'No disruption to acknowledge.'
              }
            ]
          },
          waitlistConfirmation: {
            isEligible: false,
            nonEligibilityReasons: [
              {
                code: '39408',
                title: 'Acknowledge waitlist confirmation functionality is not enabled'
              }
            ]
          }
        },
        {
          airBoundId: '1e74889e439',
          disruption: {
            isEligible: false,
            nonEligibilityReasons: [
              {
                code: '213',
                title: 'Bound already acknowledged.'
              }
            ]
          },
          waitlistConfirmation: {
            isEligible: false,
            nonEligibilityReasons: [
              {
                code: '39408',
                title: 'Acknowledge waitlist confirmation functionality is not enabled'
              }
            ]
          }
        }
      ],
      change: [
        {
          flightIds: [
            'ST3'
          ],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: [
            'ST4'
          ],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: [
            'ST5'
          ],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        }
      ],
      cancel: {
        isEligible: false
      },
      flightReaccommodation: {
        acknowledge: [
          {
            airBoundId: '1e74889e439',
            isEligible: false,
            nonEligibilityReasons: [
              {
                code: '213',
                title: 'Bound already acknowledged.'
              }
            ]
          }
        ],
        change: [
          {
            airBoundId: '1e74889e439',
            isEligible: false,
            nonEligibilityReasons: [
              {
                code: '207',
                title: 'Bound does not belong to the reference airline.'
              },
              {
                code: '211',
                title: 'Bound too far from departure.'
              },
              {
                code: '213',
                title: 'Bound already acknowledged.'
              }
            ]
          }
        ]
      }
    }
  },
  dictionaries: {
    location: {
      BOG: {
        type: 'airport',
        airportName: 'EL DORADO INTL',
        cityCode: 'BOG',
        cityName: 'BOGOTA',
        countryCode: 'CO',
        timeZone: 'UTC-0500'
      },
      SAL: {
        type: 'airport',
        airportName: 'EL SALVADOR INTL',
        cityCode: 'SAL',
        cityName: 'SAN SALVADOR',
        countryCode: 'SV',
        timeZone: 'UTC-0600'
      }
    },
    country: {
      SV: 'EL SALVADOR',
      CO: 'COLOMBIA'
    },
    airline: {
      AV: 'AVIANCA'
    },
    aircraft: {
      320: 'AIRBUS A320'
    },
    flight: {
      ST4: {
        marketingAirlineCode: 'AV',
        operatingAirlineName: 'AVIANCA',
        marketingFlightNumber: '095',
        departure: {
          locationCode: 'SAL',
          dateTime: new utils.DateTime(todayPlusNdays('15:30', 0))
        },
        arrival: {
          locationCode: 'BOG',
          dateTime: new utils.DateTime(todayPlusNdays('19:30', 0)),
          terminal: '1'
        },
        aircraftCode: '320',
        duration: 10_800,
        isOpenSegment: false,
        isInformational: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'V',
          mealCodes: [
            'N'
          ]
        },
        flightStatus: 'scheduled'
      },
      ST3: {
        marketingAirlineCode: 'AV',
        operatingAirlineCode: 'AV',
        marketingFlightNumber: '366',
        departure: {
          locationCode: 'BOG',
          dateTime: new utils.DateTime(todayPlusNdays('04:45', 0))
        },
        arrival: {
          locationCode: 'SAL',
          dateTime: new utils.DateTime(todayPlusNdays('06:50', 0))
        },
        duration: 11_100,
        isOpenSegment: false,
        isInformational: false,
        secureFlightIndicator: false
      },
      ST5: {
        marketingAirlineCode: 'AV',
        operatingAirlineName: 'TACA INTERNATIONAL AIRLINES - TACA',
        marketingFlightNumber: '382',
        departure: {
          locationCode: 'BOG',
          dateTime: new utils.DateTime(todayPlusNdays('16:20', 0)),
          terminal: '1'
        },
        arrival: {
          locationCode: 'SAL',
          dateTime: new utils.DateTime(todayPlusNdays('18:25', 0))
        },
        aircraftCode: '320',
        duration: 11_100,
        isOpenSegment: false,
        isInformational: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'V',
          mealCodes: [
            'S'
          ]
        },
        flightStatus: 'scheduled'
      }
    },
    tax: {
      YSTR: 'YSTR',
      IMEB: 'IMEB',
      DG: 'DG',
      IM: 'IM',
      DGVZ: 'DGVZ',
      IGEA: 'IGEA',
      YS: 'YS',
      IFDP: 'IFDP',
      CO: 'CO',
      IF: 'IF',
      IG: 'IG',
      COAE: 'COAE'
    },
    currency: {
      COP: {
        name: 'COLOMBIAN PESO',
        decimalPlaces: 0
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      }
    },
    meal: {
      S: 'SNACK OR BRUNCH',
      N: 'NO MEAL SERVICE'
    }
  }
};

/* Mocks with Order eligible to acknowledge only */
export const retrieveOrderMockEligibleAcknowledgeOnly = {
  warnings: [
    {
      code: '65227',
      title: 'FLIGHT DISRUPTION HAS OCCURRED: CHECK THE ORDER CONTENT'
    }
  ],
  data: {
    id: 'TBEVQ7',
    creationPointOfSale: {
      pointOfSaleId: 'HELAY08MO',
      countryCode: 'FI'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('11:09', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('11:35', -1)),
    isGroupBooking: false,
    air: {
      bounds: [
        {
          airBoundId: '15d58dd5ce4',
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          flights: [
            {
              id: 'ST3',
              cabin: 'eco',
              bookingClass: 'Y',
              statusCode: 'TK'
            }
          ],
          duration: 2400,
          disruptionStatus: {
            boundStatus: 'disrupted',
            originalFlights: [
              {
                id: 'ST1',
                cabin: 'eco',
                bookingClass: 'Y',
                statusCode: 'UN'
              }
            ],
            departure: {
              locationCode: 'HEL',
              sameAirport: true,
              sameCity: true,
              sameDay: false,
              deltaTime: -51_000
            },
            arrival: {
              locationCode: 'TKU',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: -50_700
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 0
            },
            duration: 2100
          }
        },
        {
          originLocationCode: 'TKU',
          destinationLocationCode: 'HEL',
          flights: [
            {
              id: 'ST2',
              cabin: 'eco',
              bookingClass: 'Y',
              statusCode: 'HK'
            }
          ],
          duration: 2100
        }
      ]
    },
    travelers: [
      {
        id: 'PT1',
        names: [
          {
            firstName: 'Tony',
            lastName: 'Perry',
            nameType: 'universal'
          }
        ]
      },
      {
        passengerTypeCode: 'CHD',
        id: 'PT2',
        names: [
          {
            firstName: 'Bobby',
            lastName: 'Perry',
            nameType: 'universal'
          }
        ],
        dateOfBirth: '2016-04-05'
      }
    ],
    contacts: [
      {
        id: 'OT6',
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: '7418529630',
        countryPhoneExtension: '+91'
      }
    ],
    travelDocuments: [
      {
        flightIds: ['ST2', 'ST3'],
        travelerIds: ['PT1'],
        id: '1052467303580',
        documentType: 'eticket',
        price: {
          base: 48_400,
          total: 65_948,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 8600,
              currencyCode: 'EUR',
              code: 'YR'
            },
            {
              value: 976,
              currencyCode: 'EUR',
              code: 'DQ'
            },
            {
              value: 1776,
              currencyCode: 'EUR',
              code: 'QU'
            },
            {
              value: 200,
              currencyCode: 'EUR',
              code: 'XU'
            },
            {
              value: 5996,
              currencyCode: 'EUR',
              code: 'YF'
            }
          ],
          totalTaxes: 17_548
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YPR0FI',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '229',
              departure: {
                locationCode: 'HEL',
                dateTime: new utils.DateTime(todayPlusNdays('23:45', 0))
              },
              arrival: {
                locationCode: 'TKU'
              }
            }
          },
          {
            fareClass: 'YPR0FI',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '230',
              departure: {
                locationCode: 'TKU',
                dateTime: new utils.DateTime(todayPlusNdays('06:15', 6))
              },
              arrival: {
                locationCode: 'HEL'
              }
            }
          }
        ]
      },
      {
        flightIds: ['ST2', 'ST3'],
        travelerIds: ['PT2'],
        id: '1052467303579',
        documentType: 'eticket',
        price: {
          base: 36_300,
          total: 52_638,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 8600,
              currencyCode: 'EUR',
              code: 'YR'
            },
            {
              value: 976,
              currencyCode: 'EUR',
              code: 'DQ'
            },
            {
              value: 1776,
              currencyCode: 'EUR',
              code: 'QU'
            },
            {
              value: 200,
              currencyCode: 'EUR',
              code: 'XU'
            },
            {
              value: 4786,
              currencyCode: 'EUR',
              code: 'YF'
            }
          ],
          totalTaxes: 16_338
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YPR0FI/CH',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '229',
              departure: {
                locationCode: 'HEL',
                dateTime: new utils.DateTime(todayPlusNdays('23:45', 0))
              },
              arrival: {
                locationCode: 'TKU'
              }
            }
          },
          {
            fareClass: 'YPR0FI/CH',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '230',
              departure: {
                locationCode: 'TKU',
                dateTime: new utils.DateTime(todayPlusNdays('06:15', 6))
              },
              arrival: {
                locationCode: 'HEL'
              }
            }
          }
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT3',
        code: 'CHLD',
        airlineCode: 'AY',
        statusCode: 'HK',
        quantity: 1,
        freetext: '05APR16',
        travelerIds: ['PT2']
      }
    ],
    paymentRecords: [
      {
        id: 'FPT15',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            },
            amount: {
              value: 65_948,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: ['PT1'],
        flightIds: ['ST2']
      },
      {
        id: 'FPT17',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            },
            amount: {
              value: 52_638,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: ['PT2'],
        flightIds: ['ST2']
      }
    ],
    orderEligibilities: {
      change: [
        {
          flightIds: ['ST3'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST1'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST2'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        }
      ],
      cancel: {
        isEligible: false
      },
      flightReaccommodation: {
        acknowledge: [
          {
            airBoundId: '15d58dd5ce4',
            isEligible: true,
            nonEligibilityReason: 'notActivated'
          }
        ],
        change: [
          {
            airBoundId: '15d58dd5ce4',
            isEligible: false
          }
        ]
      }
    }
  },
  dictionaries: {
    location: {
      HEL: {
        type: 'airport',
        airportName: 'HELSINKI VANTAA',
        cityCode: 'HEL',
        cityName: 'HELSINKI',
        countryCode: 'FI',
        timeZone: 'UTC+0200'
      },
      TKU: {
        type: 'airport',
        airportName: 'TURKU',
        cityCode: 'TKU',
        cityName: 'TURKU',
        countryCode: 'FI',
        timeZone: 'UTC+0200'
      }
    },
    country: {
      FI: 'FINLAND'
    },
    airline: {
      AY: 'FINNAIR'
    },
    aircraft: {
      AT7: 'AEROSPATIALE/ALENIA ATR 72'
    },
    flight: {
      ST2: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '230',
        departure: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('06:15', 6)),
          terminal: '1'
        },
        arrival: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('06:50', 6)),
          terminal: '2'
        },
        aircraftCode: 'AT7',
        duration: 2100,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      },
      ST1: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '223',
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('13:55', 1)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('14:30', 1)),
          terminal: '1'
        },
        aircraftCode: 'AT7',
        duration: 2100,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      },
      ST3: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '229',
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('23:45', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('00:25', 1)),
          terminal: '1'
        },
        aircraftCode: 'AT7',
        duration: 2400,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      }
    },
    tax: {
      QU: 'QU',
      YR: 'YR',
      DQ: 'DQ',
      XU: 'XU',
      YF: 'YF'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    specialServiceRequest: {
      CHLD: {
        name: 'CHILD PASSENGER INFORMATION'
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      },
      TK: {
        name: 'Confirmed, timechange'
      },
      UN: {
        name: 'Unable, does not operate'
      }
    },
    meal: {
      N: 'NO MEAL SERVICE'
    }
  }
};

/* Mock with group booking order with disrupted bound */
export const retrieveOrderMockGroupBooking = {
  data: {
    id: 'TBEVQ7',
    creationPointOfSale: {
      pointOfSaleId: 'HELAY08MO',
      countryCode: 'FI'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('11:09', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('11:35', -1)),
    isGroupBooking: true,
    air: {
      bounds: [
        {
          airBoundId: '15d58dd5ce4',
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          flights: [
            {
              id: 'ST3',
              cabin: 'eco',
              bookingClass: 'Y',
              statusCode: 'TK'
            }
          ],
          duration: 2400,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST1',
                cabin: 'eco',
                bookingClass: 'Y',
                statusCode: 'UN'
              }
            ],
            departure: {
              locationCode: 'HEL',
              sameAirport: true,
              sameCity: true,
              sameDay: false,
              deltaTime: -51_000
            },
            arrival: {
              locationCode: 'TKU',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: -50_700
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 0
            },
            duration: 2100
          }
        },
        {
          originLocationCode: 'TKU',
          destinationLocationCode: 'HEL',
          flights: [
            {
              id: 'ST2',
              cabin: 'eco',
              bookingClass: 'Y',
              statusCode: 'HK'
            }
          ],
          duration: 2100
        }
      ]
    },
    travelers: [
      {
        id: 'PT1',
        names: [
          {
            firstName: 'Tony',
            lastName: 'Perry',
            nameType: 'universal'
          }
        ]
      },
      {
        passengerTypeCode: 'CHD',
        id: 'PT2',
        names: [
          {
            firstName: 'Bobby',
            lastName: 'Perry',
            nameType: 'universal'
          }
        ],
        dateOfBirth: '2016-04-05'
      }
    ],
    contacts: [
      {
        id: 'OT6',
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: '7418529630',
        countryPhoneExtension: '+91'
      }
    ],
    travelDocuments: [
      {
        flightIds: ['ST2', 'ST3'],
        travelerIds: ['PT1'],
        id: '1052467303580',
        documentType: 'eticket',
        price: {
          base: 48_400,
          total: 65_948,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 8600,
              currencyCode: 'EUR',
              code: 'YR'
            },
            {
              value: 976,
              currencyCode: 'EUR',
              code: 'DQ'
            },
            {
              value: 1776,
              currencyCode: 'EUR',
              code: 'QU'
            },
            {
              value: 200,
              currencyCode: 'EUR',
              code: 'XU'
            },
            {
              value: 5996,
              currencyCode: 'EUR',
              code: 'YF'
            }
          ],
          totalTaxes: 17_548
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YPR0FI',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '229',
              departure: {
                locationCode: 'HEL',
                dateTime: new utils.DateTime(todayPlusNdays('23:45', 1))
              },
              arrival: {
                locationCode: 'TKU'
              }
            }
          },
          {
            fareClass: 'YPR0FI',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '230',
              departure: {
                locationCode: 'TKU',
                dateTime: new utils.DateTime(todayPlusNdays('06:15', 1))
              },
              arrival: {
                locationCode: 'HEL'
              }
            }
          }
        ]
      },
      {
        flightIds: ['ST2', 'ST3'],
        travelerIds: ['PT2'],
        id: '1052467303579',
        documentType: 'eticket',
        price: {
          base: 36_300,
          total: 52_638,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 8600,
              currencyCode: 'EUR',
              code: 'YR'
            },
            {
              value: 976,
              currencyCode: 'EUR',
              code: 'DQ'
            },
            {
              value: 1776,
              currencyCode: 'EUR',
              code: 'QU'
            },
            {
              value: 200,
              currencyCode: 'EUR',
              code: 'XU'
            },
            {
              value: 4786,
              currencyCode: 'EUR',
              code: 'YF'
            }
          ],
          totalTaxes: 16_338
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YPR0FI/CH',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '229',
              departure: {
                locationCode: 'HEL',
                dateTime: new utils.DateTime(todayPlusNdays('23:45', 0))
              },
              arrival: {
                locationCode: 'TKU'
              }
            }
          },
          {
            fareClass: 'YPR0FI/CH',
            fareFamilyCode: 'PRO',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AY',
              marketingFlightNumber: '230',
              departure: {
                locationCode: 'TKU',
                dateTime: new utils.DateTime(todayPlusNdays('06:15', 6))
              },
              arrival: {
                locationCode: 'HEL'
              }
            }
          }
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT3',
        code: 'CHLD',
        airlineCode: 'AY',
        statusCode: 'HK',
        quantity: 1,
        freetext: '05APR16',
        travelerIds: ['PT2']
      }
    ],
    paymentRecords: [
      {
        id: 'FPT15',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            },
            amount: {
              value: 65_948,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: ['PT1'],
        flightIds: ['ST2']
      },
      {
        id: 'FPT17',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1022'
            },
            amount: {
              value: 52_638,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: ['PT2'],
        flightIds: ['ST2']
      }
    ],
    orderEligibilities: {
      change: [
        {
          flightIds: ['ST3'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST1'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST2'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        }
      ],
      cancel: {
        isEligible: false
      }
    },
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: '15d58dd5ce4',
          isEligible: true,
          nonEligibilityReason: 'notActivated'
        }
      ],
      change: [
        {
          airBoundId: '15d58dd5ce4',
          isEligible: true
        }
      ]
    }
  },
  dictionaries: {
    location: {
      HEL: {
        type: 'airport',
        airportName: 'HELSINKI VANTAA',
        cityCode: 'HEL',
        cityName: 'HELSINKI',
        countryCode: 'FI',
        timeZone: 'UTC+0200'
      },
      TKU: {
        type: 'airport',
        airportName: 'TURKU',
        cityCode: 'TKU',
        cityName: 'TURKU',
        countryCode: 'FI',
        timeZone: 'UTC+0200'
      }
    },
    country: {
      FI: 'FINLAND'
    },
    airline: {
      AY: 'FINNAIR'
    },
    aircraft: {
      AT7: 'AEROSPATIALE/ALENIA ATR 72'
    },
    flight: {
      ST2: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '230',
        departure: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('06:15', 6)),
          terminal: '1'
        },
        arrival: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('06:50', 6)),
          terminal: '2'
        },
        aircraftCode: 'AT7',
        duration: 2100,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      },
      ST1: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '223',
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('13:55', 1)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('14:30', 1)),
          terminal: '1'
        },
        aircraftCode: 'AT7',
        duration: 2100,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      },
      ST3: {
        marketingAirlineCode: 'AY',
        operatingAirlineName: 'NORDIC REGIONAL AIRLINES',
        marketingFlightNumber: '229',
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('23:45', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('00:25', 1)),
          terminal: '1'
        },
        aircraftCode: 'AT7',
        duration: 2400,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['N']
        }
      }
    },
    tax: {
      QU: 'QU',
      YR: 'YR',
      DQ: 'DQ',
      XU: 'XU',
      YF: 'YF'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    specialServiceRequest: {
      CHLD: {
        name: 'CHILD PASSENGER INFORMATION'
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      },
      TK: {
        name: 'Confirmed, timechange'
      },
      UN: {
        name: 'Unable, does not operate'
      }
    },
    meal: {
      N: 'NO MEAL SERVICE'
    }
  }
};

/*
 * Mocks for check-in
 */
export const retrieveOrderMockCheckinInitial = {
  warnings: [
    {
      code: '65227',
      title: 'FLIGHT DISRUPTION HAS OCCURRED: CHECK THE ORDER CONTENT'
    }
  ],
  data: {
    id: 'R3SVSI',
    creationPointOfSale: {
      pointOfSaleId: 'PARAF0ERS',
      countryCode: 'FR'
    },
    servicingPointOfSale: {
      pointOfSaleId: 'PARAF1234',
      countryCode: 'FR'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('04:46', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('04:50', -1)),
    isGroupBooking: false,
    air: {
      prices: {
        unitPrices: [
          {
            travelerIds: ['PT1'],
            prices: [
              {
                base: {
                  value: 79_200,
                  currencyCode: 'EUR'
                },
                total: {
                  value: 85_310,
                  currencyCode: 'EUR'
                },
                taxes: [
                  {
                    value: 463,
                    currencyCode: 'EUR',
                    code: 'FRSE'
                  },
                  {
                    value: 1170,
                    currencyCode: 'EUR',
                    code: 'FRTI'
                  },
                  {
                    value: 113,
                    currencyCode: 'EUR',
                    code: 'IZEB'
                  },
                  {
                    value: 150,
                    currencyCode: 'EUR',
                    code: 'O4VC'
                  },
                  {
                    value: 1214,
                    currencyCode: 'EUR',
                    code: 'QXAP'
                  }
                ],
                totalTaxes: {
                  value: 3110,
                  currencyCode: 'EUR'
                },
                fees: [
                  {
                    value: 3000,
                    currencyCode: 'EUR',
                    nature: 'ticketing'
                  }
                ],
                totalFees: {
                  value: 3000,
                  currencyCode: 'EUR'
                }
              }
            ]
          }
        ],
        totalPrices: [
          {
            base: {
              value: 79_200,
              currencyCode: 'EUR'
            },
            total: {
              value: 85_310,
              currencyCode: 'EUR'
            },
            totalTaxes: {
              value: 3110,
              currencyCode: 'EUR'
            },
            totalFees: {
              value: 3000,
              currencyCode: 'EUR'
            }
          }
        ]
      },
      bounds: [
        {
          airBoundId: '1915634eab8',
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          flights: [
            {
              id: 'ST2',
              cabin: 'eco',
              bookingClass: 'Y',
              statusCode: 'TK'
            }
          ],
          duration: 4500,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST1',
                cabin: 'eco',
                bookingClass: 'Y',
                statusCode: 'UN'
              }
            ],
            departure: {
              locationCode: 'CDG',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: -16_800
            },
            arrival: {
              locationCode: 'ZRH',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: -17_100
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 0
            },
            duration: 4800
          }
        }
      ],
      freeCheckedBaggageAllowanceItems: [
        {
          details: {
            type: 'piece',
            quantity: 1
          },
          flightIds: ['ST1'],
          travelerIds: ['PT1']
        }
      ]
    },
    travelers: [
      {
        id: 'PT1',
        names: [
          {
            firstName: 'C',
            lastName: 'Srtst',
            nameType: 'universal',
            isPreferred: true
          }
        ]
      }
    ],
    contacts: [
      {
        id: 'OT2',
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: 'PAR - AIR FRANCE - A'
      }
    ],
    travelDocuments: [
      {
        flightIds: ['ST2'],
        travelerIds: ['PT1'],
        id: '0571443980305',
        documentType: 'eticket',
        price: {
          base: 79_200,
          total: 82_310,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 463,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 1170,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 113,
              currencyCode: 'EUR',
              code: 'IZ'
            },
            {
              value: 150,
              currencyCode: 'EUR',
              code: 'O4'
            },
            {
              value: 1214,
              currencyCode: 'EUR',
              code: 'QX'
            }
          ],
          totalTaxes: 3110
        },
        fareInfos: [
          {
            fareClass: 'YS40BENN',
            couponStatus: 'checkedIn',
            flight: {
              marketingAirlineCode: 'AF',
              marketingFlightNumber: '1814',
              departure: {
                locationCode: 'CDG',
                dateTime: new utils.DateTime(todayPlusNdays('16:40', 0))
              },
              arrival: {
                locationCode: 'ZRH',
                dateTime: new utils.DateTime(todayPlusNdays('17:55', 0))
              }
            }
          }
        ]
      }
    ],
    orderEligibilities: {
      change: [
        {
          flightIds: ['ST2'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST1'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        }
      ],
      cancel: {
        isEligible: false
      },
      flightReaccommodation: {
        acknowledge: [
          {
            airBoundId: '1915634eab8',
            isEligible: true
          }
        ],
        change: [
          {
            airBoundId: '1915634eab8',
            isEligible: true
          }
        ]
      }
    }
  },
  dictionaries: {
    location: {
      PAR: {
        type: 'city',
        cityCode: 'PAR',
        cityName: 'PARIS',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      },
      ZRH: {
        type: 'airport',
        airportName: 'ZURICH AIRPORT',
        cityCode: 'ZRH',
        cityName: 'ZURICH',
        countryCode: 'CH',
        timeZone: 'UTC+0200'
      },
      CDG: {
        type: 'airport',
        airportName: 'CHARLES DE GAULLE',
        cityCode: 'PAR',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      }
    },
    country: {
      CH: 'SWITZERLAND',
      FR: 'FRANCE'
    },
    airline: {
      AF: 'AIR FRANCE'
    },
    aircraft: {
      318: 'AIRBUS A318'
    },
    flight: {
      ST2: {
        marketingAirlineCode: 'AF',
        operatingAirlineCode: 'AF',
        marketingFlightNumber: '1814',
        operatingAirlineFlightNumber: '1814',
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('16:40', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('17:55', 0))
        },
        aircraftCode: '318',
        duration: 4500,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['S']
        }
      },
      ST1: {
        marketingAirlineCode: 'AF',
        operatingAirlineCode: 'AF',
        marketingFlightNumber: '1414',
        operatingAirlineFlightNumber: '1414',
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('21:20', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('22:40', 0))
        },
        aircraftCode: '318',
        duration: 4800,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['S']
        },
        flightStatus: 'cancelled'
      }
    },
    tax: {
      FRTI: 'FRTI',
      QXAP: 'QXAP',
      IZ: 'IZ',
      O4: 'O4',
      O4VC: 'O4VC',
      QX: 'QX',
      IZEB: 'IZEB',
      FR: 'FR',
      FRSE: 'FRSE'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    bookingStatus: {
      TK: {
        name: 'Confirmed, timechange'
      },
      UN: {
        name: 'Unable, does not operate'
      }
    },
    meal: {
      S: 'SNACK OR BRUNCH'
    }
  }
};

export const retrieveOrderMockCheckinFailedLast = {
  data: {
    id: 'R3SVSI',
    creationPointOfSale: {
      pointOfSaleId: 'PARAF0ERS',
      countryCode: 'FR'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('04:46', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('06:25', -1)),
    isGroupBooking: false,
    air: {
      bounds: [
        {
          airBoundId: '1915634eab8',
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          flights: [
            {
              id: 'ST3',
              cabin: 'eco',
              bookingClass: 'Y',
              statusCode: 'HK'
            }
          ],
          duration: 4800,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST1'
              }
            ],
            departure: {
              locationCode: 'CDG',
              sameAirport: true,
              sameCity: true,
              sameDay: false,
              deltaTime: -86_400
            },
            arrival: {
              locationCode: 'ZRH',
              sameAirport: true,
              sameCity: true,
              sameDay: false,
              deltaTime: -86_400
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 0
            },
            duration: 4800
          }
        }
      ]
    },
    services: [
      {
        id: 'OT32',
        descriptions: [
          {
            type: 'shortText',
            content: 'ADTK'
          }
        ],
        quantity: 1,
        statusCode: ' ',
        parameters: [
          {
            code: 'TEXT',
            value: 'TO AF BY 27APR 1100 PAR OTHERWISE WILL BE XLD'
          }
        ]
      }
    ],
    travelers: [
      {
        id: 'PT1',
        names: [
          {
            firstName: 'C',
            lastName: 'Srtst',
            nameType: 'universal',
            isPreferred: true
          }
        ]
      }
    ],
    contacts: [
      {
        id: 'OT2',
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: 'PAR - AIR FRANCE - A'
      }
    ],
    travelDocuments: [
      {
        flightIds: ['ST3'],
        travelerIds: ['PT1'],
        id: '0571443980305',
        documentType: 'eticket',
        price: {
          base: 79_200,
          total: 82_310,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 463,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 1170,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 113,
              currencyCode: 'EUR',
              code: 'IZ'
            },
            {
              value: 150,
              currencyCode: 'EUR',
              code: 'O4'
            },
            {
              value: 1214,
              currencyCode: 'EUR',
              code: 'QX'
            }
          ],
          totalTaxes: 3110
        },
        fareInfos: [
          {
            fareClass: 'YS40BENN',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'AF',
              marketingFlightNumber: '1414',
              departure: {
                locationCode: 'CDG',
                dateTime: new utils.DateTime(todayPlusNdays('21:20', 0))
              },
              arrival: {
                locationCode: 'ZRH',
                dateTime: new utils.DateTime(todayPlusNdays('22:40', 0))
              }
            }
          }
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT32',
        code: 'ADTK',
        airlineCode: '1A',
        statusCode: ' ',
        freetext: 'TO AF BY 27APR 1100 PAR OTHERWISE WILL BE XLD'
      }
    ],
    orderEligibilities: {
      change: [
        {
          flightIds: ['ST3'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST1'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        }
      ],
      cancel: {
        isEligible: false
      },
      flightReaccommodation: {
        change: [
          {
            airBoundId: '1915634eab8',
            isEligible: false,
            nonEligibilityReasons: [
              {
                code: '200',
                title: 'Bound too close to departure.'
              },
              {
                code: '206',
                title: 'Bound has already been rebooked via SELF channel.'
              }
            ]
          }
        ]
      }
    }
  },
  dictionaries: {
    location: {
      PAR: {
        type: 'city',
        cityCode: 'PAR',
        cityName: 'PARIS',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      },
      ZRH: {
        type: 'airport',
        airportName: 'ZURICH AIRPORT',
        cityCode: 'ZRH',
        cityName: 'ZURICH',
        countryCode: 'CH',
        timeZone: 'UTC+0200'
      },
      CDG: {
        type: 'airport',
        airportName: 'CHARLES DE GAULLE',
        cityCode: 'PAR',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      }
    },
    country: {
      CH: 'SWITZERLAND',
      FR: 'FRANCE'
    },
    airline: {
      AF: 'AIR FRANCE'
    },
    aircraft: {
      318: 'AIRBUS A318'
    },
    flight: {
      ST1: {
        marketingAirlineCode: 'AF',
        operatingAirlineCode: 'AF',
        marketingFlightNumber: '1414',
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('19:20', 0))
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('20:40', 0))
        },
        duration: 4800,
        isOpenSegment: false,
        secureFlightIndicator: false
      },
      ST3: {
        marketingAirlineCode: 'AF',
        operatingAirlineCode: 'AF',
        marketingFlightNumber: '1414',
        operatingAirlineFlightNumber: '1414',
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('21:20', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('22:40', 0))
        },
        aircraftCode: '318',
        duration: 4800,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['S']
        },
        flightStatus: 'scheduled'
      }
    },
    tax: {
      IZ: 'IZ',
      O4: 'O4',
      QX: 'QX',
      FR: 'FR'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    specialServiceRequest: {
      ADTK: {
        name: 'REQUEST TO ADD TICKET INFORMATION'
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      }
    },
    meal: {
      S: 'SNACK OR BRUNCH'
    }
  }
};

export const retrieveOrderMockCheckinSucceededLast = {
  warnings: [
    {
      code: '39610',
      title: 'LOST SERVICES'
    }
  ],
  data: {
    id: 'R3SVSI',
    creationPointOfSale: {
      pointOfSaleId: 'PARAF0ERS',
      countryCode: 'FR'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('04:46', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('06:25', -1)),
    isGroupBooking: false,
    air: {
      bounds: [
        {
          airBoundId: '1915634eab8',
          originLocationCode: 'CDG',
          destinationLocationCode: 'ZRH',
          flights: [
            {
              id: 'ST3',
              cabin: 'eco',
              bookingClass: 'Y',
              statusCode: 'HK'
            }
          ],
          duration: 4800,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST1'
              }
            ],
            departure: {
              locationCode: 'CDG',
              sameAirport: true,
              sameCity: true,
              sameDay: false,
              deltaTime: -86_400
            },
            arrival: {
              locationCode: 'ZRH',
              sameAirport: true,
              sameCity: true,
              sameDay: false,
              deltaTime: -86_400
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 0
            },
            duration: 4800
          }
        }
      ]
    },
    services: [
      {
        id: 'TSM16',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          },
          {
            type: 'longText',
            content: '1ST ADDITIONAL BAG'
          }
        ],
        quantity: 1,
        flightIds: ['ST3'],
        statusCode: 'HK',
        travelerId: 'PT1',
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: {
                    value: 10_000,
                    currencyCode: 'EUR'
                  },
                  total: {
                    value: 10_000,
                    currencyCode: 'EUR'
                  }
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: {
                value: 10_000,
                currencyCode: 'EUR'
              },
              total: {
                value: 10_000,
                currencyCode: 'EUR'
              }
            }
          ]
        },
        details: [
          {
            flightId: 'ST3',
            quantity: 1
          }
        ]
      },
      {
        id: 'OT58',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        quantity: 1,
        tags: ['C'],
        flightIds: ['ST3'],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true
      },
      {
        id: 'OT60',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        quantity: 1,
        tags: ['C'],
        flightIds: ['ST3'],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true
      },
      {
        id: 'OT32',
        descriptions: [
          {
            type: 'shortText',
            content: 'ADTK'
          }
        ],
        quantity: 1,
        statusCode: ' ',
        parameters: [
          {
            code: 'TEXT',
            value: 'TO AF BY 27APR 1100 PAR OTHERWISE WILL BE XLD'
          }
        ]
      }
    ],
    travelers: [
      {
        id: 'PT1',
        passengerTypeCode: 'ADT',
        names: [
          {
            firstName: 'C',
            lastName: 'Srtst',
            nameType: 'universal',
            isPreferred: true
          }
        ]
      }
    ],
    contacts: [
      {
        id: 'OT2',
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: 'PAR - AIR FRANCE - A'
      }
    ],
    travelDocuments: [
      {
        flightIds: ['ST3'],
        travelerIds: ['PT1'],
        id: '0571443980305',
        documentType: 'eticket',
        price: {
          base: 79_200,
          total: 82_310,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 463,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 1170,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 113,
              currencyCode: 'EUR',
              code: 'IZ'
            },
            {
              value: 150,
              currencyCode: 'EUR',
              code: 'O4'
            },
            {
              value: 1214,
              currencyCode: 'EUR',
              code: 'QX'
            }
          ],
          totalTaxes: 3110
        },
        fareInfos: [
          {
            fareClass: 'YS40BENN',
            couponStatus: 'checkedIn',
            flight: {
              marketingAirlineCode: 'AF',
              marketingFlightNumber: '1414',
              departure: {
                locationCode: 'CDG',
                dateTime: new utils.DateTime(todayPlusNdays('21:20', 0))
              },
              arrival: {
                locationCode: 'ZRH',
                dateTime: new utils.DateTime(todayPlusNdays('22:40', 0))
              }
            }
          }
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT32',
        code: 'ADTK',
        airlineCode: '1A',
        statusCode: ' ',
        freetext: 'TO AF BY 27APR 1100 PAR OTHERWISE WILL BE XLD'
      }
    ],
    orderEligibilities: {
      change: [
        {
          flightIds: ['ST3'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        },
        {
          flightIds: ['ST1'],
          isEligible: false,
          nonEligibilityReason: 'flightChangeNotActivated',
          isPenaltyApplied: false
        }
      ],
      cancel: {
        isEligible: false
      },
      flightReaccommodation: {
        change: [
          {
            airBoundId: '1915634eab8',
            isEligible: false,
            nonEligibilityReasons: [
              {
                code: '200',
                title: 'Bound too close to departure.'
              },
              {
                code: '206',
                title: 'Bound has already been rebooked via SELF channel.'
              }
            ]
          }
        ]
      }
    }
  },
  dictionaries: {
    location: {
      PAR: {
        type: 'city',
        cityCode: 'PAR',
        cityName: 'PARIS',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      },
      ZRH: {
        type: 'airport',
        airportName: 'ZURICH AIRPORT',
        cityCode: 'ZRH',
        cityName: 'ZURICH',
        countryCode: 'CH',
        timeZone: 'UTC+0200'
      },
      CDG: {
        type: 'airport',
        airportName: 'CHARLES DE GAULLE',
        cityCode: 'PAR',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      }
    },
    country: {
      CH: 'SWITZERLAND',
      FR: 'FRANCE'
    },
    airline: {
      AF: 'AIR FRANCE'
    },
    aircraft: {
      318: 'AIRBUS A318'
    },
    flight: {
      ST1: {
        marketingAirlineCode: 'AF',
        operatingAirlineCode: 'AF',
        marketingFlightNumber: '1414',
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('19:20', 0))
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('20:40', 0))
        },
        duration: 4800,
        isOpenSegment: false,
        secureFlightIndicator: false
      },
      ST3: {
        marketingAirlineCode: 'AF',
        operatingAirlineCode: 'AF',
        marketingFlightNumber: '1414',
        operatingAirlineFlightNumber: '1414',
        departure: {
          locationCode: 'CDG',
          dateTime: new utils.DateTime(todayPlusNdays('21:20', 0)),
          terminal: '2F'
        },
        arrival: {
          locationCode: 'ZRH',
          dateTime: new utils.DateTime(todayPlusNdays('22:40', 0))
        },
        aircraftCode: '318',
        duration: 4800,
        isOpenSegment: false,
        secureFlightIndicator: false,
        meals: {
          bookingClass: 'Y',
          mealCodes: ['S']
        },
        flightStatus: 'scheduled'
      }
    },
    tax: {
      IZ: 'IZ',
      O4: 'O4',
      QX: 'QX',
      FR: 'FR'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    specialServiceRequest: {
      ADTK: {
        name: 'REQUEST TO ADD TICKET INFORMATION'
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      }
    },
    meal: {
      S: 'SNACK OR BRUNCH'
    }
  }
};

export const retrieveOrderMockEligibleToRefundWithServices = {
  data: {
    id: 'K26CZX',
    creationPointOfSale: {
      pointOfSaleId: 'NCE6X0100',
      countryCode: 'FR'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('12:07', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('12:54', -1)),
    isGroupBooking: false,
    air: {
      prices: {
        unitPrices: [
          {
            travelerIds: [
              'PT2'
            ],
            prices: [
              {
                base: {
                  value: 20_000,
                  currencyCode: 'EUR'
                },
                total: {
                  value: 26_110,
                  currencyCode: 'EUR'
                },
                taxes: [
                  {
                    value: 463,
                    currencyCode: 'EUR',
                    code: 'FRSE'
                  },
                  {
                    value: 785,
                    currencyCode: 'EUR',
                    code: 'FRTI'
                  },
                  {
                    value: 113,
                    currencyCode: 'EUR',
                    code: 'IZEB'
                  },
                  {
                    value: 150,
                    currencyCode: 'EUR',
                    code: 'O4VC'
                  },
                  {
                    value: 725,
                    currencyCode: 'EUR',
                    code: 'QXAP'
                  },
                  {
                    value: 1497,
                    currencyCode: 'EUR',
                    code: 'GBAD'
                  },
                  {
                    value: 2377,
                    currencyCode: 'EUR',
                    code: 'UBAS'
                  }
                ],
                totalTaxes: {
                  value: 6110,
                  currencyCode: 'EUR'
                }
              }
            ]
          }
        ],
        totalPrices: [
          {
            base: {
              value: 20_000,
              currencyCode: 'EUR'
            },
            total: {
              value: 26_110,
              currencyCode: 'EUR'
            },
            totalTaxes: {
              value: 6110,
              currencyCode: 'EUR'
            }
          }
        ]
      },
      bounds: [
        {
          airBoundId: 1,
          originLocationCode: 'NCE',
          destinationLocationCode: 'LHR',
          flights: [
            {
              id: 'ST1',
              cabin: 'eco',
              bookingClass: 'B',
              statusCode: 'HK',
              fareFamilyCode: '-ALL-'
            }
          ],
          duration: 7200
        },
        {
          airBoundId: 2,
          originLocationCode: 'LHR',
          destinationLocationCode: 'NCE',
          flights: [
            {
              id: 'ST2',
              cabin: 'eco',
              bookingClass: 'B',
              statusCode: 'HK',
              fareFamilyCode: '-ALL-'
            }
          ],
          duration: 3600
        }
      ],
      freeCheckedBaggageAllowanceItems: [
        {
          details: {
            type: 'weight',
            weightUnit: 'kilogram',
            quantity: 23
          },
          flightIds: [
            'ST1'
          ],
          travelerIds: [
            'PT2'
          ]
        },
        {
          details: {
            type: 'weight',
            weightUnit: 'kilogram',
            quantity: 23
          },
          flightIds: [
            'ST2'
          ],
          travelerIds: [
            'PT2'
          ]
        }
      ]
    },
    services: [
      {
        id: 'TSM8',
        descriptions: [
          {
            type: 'shortText',
            content: 'HBAG'
          },
          {
            type: 'longText',
            content: 'HOCKEY EQUIPMENT'
          }
        ],
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        parameters: [
          {
            code: 'TEXT',
            value: 'TTL 3KG 0PC'
          }
        ],
        travelerId: 'PT2',
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: {
                    value: 90,
                    currencyCode: 'EUR'
                  },
                  total: {
                    value: 90,
                    currencyCode: 'EUR'
                  }
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: {
                value: 90,
                currencyCode: 'EUR'
              },
              total: {
                value: 90,
                currencyCode: 'EUR'
              }
            }
          ]
        }
      },
      {
        id: 'OT32',
        descriptions: [
          {
            type: 'shortText',
            content: 'BAGA'
          }
        ],
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        parameters: [
          {
            code: 'TEXT',
            value: 'TTL23KG'
          }
        ],
        travelerId: 'PT2'
      },
      {
        id: 'OT33',
        descriptions: [
          {
            type: 'shortText',
            content: 'BAGA'
          }
        ],
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'HK',
        parameters: [
          {
            code: 'TEXT',
            value: 'TTL23KG'
          }
        ],
        travelerId: 'PT2'
      }
    ],
    travelers: [
      {
        passengerTypeCode: 'ADT',
        id: 'PT2',
        names: [
          {
            firstName: 'Islee',
            lastName: 'Myname',
            nameType: 'universal',
            isPreferred: true
          }
        ],
        dateOfBirth: '1990-01-01'
      }
    ],
    contacts: [
      {
        id: 'OT3',
        travelerIds: [
          'PT2'
        ],
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: '3399998888-M'
      },
      {
        id: 'OT4',
        travelerIds: [
          'PT2'
        ],
        category: 'personal',
        contactType: 'Email',
        purpose: 'standard',
        address: 'TEST@AMADEUS.COM'
      }
    ],
    travelDocuments: [
      {
        flightIds: [
          'ST1',
          'ST2'
        ],
        travelerIds: [
          'PT2'
        ],
        id: 1_722_400_159_180,
        documentType: 'eticket',
        price: {
          base: 20_000,
          total: 26_110,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 463,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 785,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 113,
              currencyCode: 'EUR',
              code: 'IZ'
            },
            {
              value: 150,
              currencyCode: 'EUR',
              code: 'O4'
            },
            {
              value: 725,
              currencyCode: 'EUR',
              code: 'QX'
            },
            {
              value: 1497,
              currencyCode: 'EUR',
              code: 'GB'
            },
            {
              value: 2377,
              currencyCode: 'EUR',
              code: 'UB'
            }
          ],
          totalTaxes: 6110
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'BRVRT',
            fareFamilyCode: '-ALL-',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: '6X',
              marketingFlightNumber: 9891,
              departure: {
                locationCode: 'NCE',
                dateTime: new utils.DateTime(todayPlusNdays('08:00', 1))
              },
              arrival: {
                locationCode: 'LHR',
                dateTime: new utils.DateTime(todayPlusNdays('09:00', 1))
              }
            }
          },
          {
            fareClass: 'BRVRT',
            fareFamilyCode: '-ALL-',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: '6X',
              marketingFlightNumber: 404,
              departure: {
                locationCode: 'LHR',
                dateTime: new utils.DateTime(todayPlusNdays('16:00', 2))
              },
              arrival: {
                locationCode: 'NCE',
                dateTime: new utils.DateTime(todayPlusNdays('18:00', 2))
              }
            }
          }
        ]
      },
      {
        serviceIds: [
          'TSM8'
        ],
        travelerIds: [
          'PT2'
        ],
        id: 1_728_200_024_934,
        documentType: 'services',
        price: {
          base: 90,
          total: 90,
          currencyCode: 'EUR'
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            }
          }
        ]
      }
    ],
    otherServiceInformations: [
      {
        id: 'OT13',
        airlineCode: '6X',
        freetext: 'ARRIVAL AIRPORT LHR'
      }
    ],
    specialKeywords: [
      {
        id: 'OT14',
        keyword: 'JTOP',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'SK FREETEXT FOR CHD PASSENGERS []',
        flightIds: [
          'ST1'
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT7',
        code: 'HBAG',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL 3KG 0PC',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT32',
        code: 'BAGA',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL23KG',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT33',
        code: 'BAGA',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL23KG',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST2'
        ]
      }
    ],
    paymentRecords: [
      {
        id: 'FPT8',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            },
            amount: {
              value: 90,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        serviceItemIds: [
          'TSM8'
        ]
      },
      {
        id: 'FPT25',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            },
            amount: {
              value: 26_110,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1',
          'ST2'
        ]
      }
    ]
  },
  dictionaries: {
    location: {
      NCE: {
        type: 'airport',
        airportName: 'COTE D AZUR',
        cityCode: 'NCE',
        cityName: 'NICE',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      },
      LHR: {
        type: 'airport',
        airportName: 'HEATHROW',
        cityCode: 'LON',
        countryCode: 'GB',
        timeZone: 'UTC+0100'
      },
      LON: {
        type: 'city',
        cityCode: 'LON',
        cityName: 'LONDON',
        countryCode: 'GB',
        timeZone: 'UTC+0100'
      }
    },
    country: {
      GB: 'UNITED KINGDOM',
      FR: 'FRANCE'
    },
    airline: {
      '6X': 'AMADEUS SIX'
    },
    aircraft: {
      320: 'AIRBUS A320',
      343: 'AIRBUS A340-300'
    },
    flight: {
      ST2: {
        marketingAirlineCode: '6X',
        operatingAirlineCode: '6X',
        marketingFlightNumber: 404,
        operatingAirlineFlightNumber: 404,
        departure: {
          locationCode: 'LHR',
          dateTime: new utils.DateTime(todayPlusNdays('16:00', 4))
        },
        arrival: {
          locationCode: 'NCE',
          dateTime: new utils.DateTime(todayPlusNdays('18:00', 4))
        },
        aircraftCode: 320,
        duration: 3600,
        isOpenSegment: false,
        secureFlightIndicator: false,
        flightStatus: 'scheduled'
      },
      ST1: {
        marketingAirlineCode: '6X',
        operatingAirlineCode: '6X',
        marketingFlightNumber: 9891,
        operatingAirlineFlightNumber: 9891,
        departure: {
          locationCode: 'NCE',
          dateTime: new utils.DateTime(todayPlusNdays('08:00', 1)),
          terminal: 1
        },
        arrival: {
          locationCode: 'LHR',
          dateTime: new utils.DateTime(todayPlusNdays('09:00', 1)),
          terminal: 5
        },
        aircraftCode: 343,
        duration: 7200,
        isOpenSegment: false,
        secureFlightIndicator: false,
        flightStatus: 'scheduled'
      }
    },
    tax: {
      FRTI: 'FRTI',
      O4: 'O4',
      QX: 'QX',
      IZEB: 'IZEB',
      FR: 'FR',
      UB: 'UB',
      QXAP: 'QXAP',
      IZ: 'IZ',
      O4VC: 'O4VC',
      UBAS: 'UBAS',
      GB: 'GB',
      FRSE: 'FRSE',
      GBAD: 'GBAD'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      }
    }
  }
};

export const retrieveOrderMockEligibleToRefundWithInsurances = {
  data: {
    id: 'K26CZX',
    creationPointOfSale: {
      pointOfSaleId: 'NCE6X0100',
      countryCode: 'FR'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('12:07', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('12:54', -1)),
    isGroupBooking: false,
    air: {
      prices: {
        unitPrices: [
          {
            travelerIds: [
              'PT2'
            ],
            prices: [
              {
                base: {
                  value: 20_000,
                  currencyCode: 'EUR'
                },
                total: {
                  value: 26_110,
                  currencyCode: 'EUR'
                },
                taxes: [
                  {
                    value: 463,
                    currencyCode: 'EUR',
                    code: 'FRSE'
                  },
                  {
                    value: 785,
                    currencyCode: 'EUR',
                    code: 'FRTI'
                  },
                  {
                    value: 113,
                    currencyCode: 'EUR',
                    code: 'IZEB'
                  },
                  {
                    value: 150,
                    currencyCode: 'EUR',
                    code: 'O4VC'
                  },
                  {
                    value: 725,
                    currencyCode: 'EUR',
                    code: 'QXAP'
                  },
                  {
                    value: 1497,
                    currencyCode: 'EUR',
                    code: 'GBAD'
                  },
                  {
                    value: 2377,
                    currencyCode: 'EUR',
                    code: 'UBAS'
                  }
                ],
                totalTaxes: {
                  value: 6110,
                  currencyCode: 'EUR'
                }
              }
            ]
          }
        ],
        totalPrices: [
          {
            base: {
              value: 20_000,
              currencyCode: 'EUR'
            },
            total: {
              value: 26_110,
              currencyCode: 'EUR'
            },
            totalTaxes: {
              value: 6110,
              currencyCode: 'EUR'
            }
          }
        ]
      },
      bounds: [
        {
          airBoundId: 1,
          originLocationCode: 'NCE',
          destinationLocationCode: 'LHR',
          flights: [
            {
              id: 'ST1',
              cabin: 'eco',
              bookingClass: 'B',
              statusCode: 'HK',
              fareFamilyCode: '-ALL-'
            }
          ],
          duration: 7200
        },
        {
          airBoundId: 2,
          originLocationCode: 'LHR',
          destinationLocationCode: 'NCE',
          flights: [
            {
              id: 'ST2',
              cabin: 'eco',
              bookingClass: 'B',
              statusCode: 'HK',
              fareFamilyCode: '-ALL-'
            }
          ],
          duration: 3600
        }
      ],
      freeCheckedBaggageAllowanceItems: [
        {
          details: {
            type: 'weight',
            weightUnit: 'kilogram',
            quantity: 23
          },
          flightIds: [
            'ST1'
          ],
          travelerIds: [
            'PT2'
          ]
        },
        {
          details: {
            type: 'weight',
            weightUnit: 'kilogram',
            quantity: 23
          },
          flightIds: [
            'ST2'
          ],
          travelerIds: [
            'PT2'
          ]
        }
      ]
    },
    insurances: [
      {
        insuranceProviderCode: 'TGC',
        countryCode: 'GB',
        product: {
          code: 'INS_1'
        },
        prices: {
          totalPrice: {
            total: 500,
            currencyCode: 'EUR',
            totalTaxes: 0,
            currency: {
              name: 'EUR',
              decimalPlaces: 2
            }
          }
        },
        id: 'INS_1',
        confirmationNumber: '012345',
        statusCode: 'HK',
        insuranceProvider: {},
        status: {
          name: 'Confirmed'
        }
      }
    ],
    travelers: [
      {
        passengerTypeCode: 'ADT',
        id: 'PT2',
        names: [
          {
            firstName: 'Islee',
            lastName: 'Myname',
            nameType: 'universal',
            isPreferred: true
          }
        ],
        dateOfBirth: '1990-01-01'
      }
    ],
    contacts: [
      {
        id: 'OT3',
        travelerIds: [
          'PT2'
        ],
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: '3399998888-M'
      },
      {
        id: 'OT4',
        travelerIds: [
          'PT2'
        ],
        category: 'personal',
        contactType: 'Email',
        purpose: 'standard',
        address: 'TEST@AMADEUS.COM'
      }
    ],
    travelDocuments: [
      {
        flightIds: [
          'ST1',
          'ST2'
        ],
        travelerIds: [
          'PT2'
        ],
        id: 1_722_400_159_180,
        documentType: 'eticket',
        price: {
          base: 20_000,
          total: 26_110,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 463,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 785,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 113,
              currencyCode: 'EUR',
              code: 'IZ'
            },
            {
              value: 150,
              currencyCode: 'EUR',
              code: 'O4'
            },
            {
              value: 725,
              currencyCode: 'EUR',
              code: 'QX'
            },
            {
              value: 1497,
              currencyCode: 'EUR',
              code: 'GB'
            },
            {
              value: 2377,
              currencyCode: 'EUR',
              code: 'UB'
            }
          ],
          totalTaxes: 6110
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'BRVRT',
            fareFamilyCode: '-ALL-',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: '6X',
              marketingFlightNumber: 9891,
              departure: {
                locationCode: 'NCE',
                dateTime: new utils.DateTime(todayPlusNdays('08:00', 3))
              },
              arrival: {
                locationCode: 'LHR',
                dateTime: new utils.DateTime(todayPlusNdays('09:00', 3))
              }
            }
          },
          {
            fareClass: 'BRVRT',
            fareFamilyCode: '-ALL-',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: '6X',
              marketingFlightNumber: 404,
              departure: {
                locationCode: 'LHR',
                dateTime: new utils.DateTime(todayPlusNdays('16:00', 1))
              },
              arrival: {
                locationCode: 'NCE',
                dateTime: new utils.DateTime(todayPlusNdays('18:00', 1))
              }
            }
          }
        ]
      },
      {
        serviceIds: [
          'TSM8'
        ],
        travelerIds: [
          'PT2'
        ],
        id: 1_728_200_024_934,
        documentType: 'services',
        price: {
          base: 90,
          total: 90,
          currencyCode: 'EUR'
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            }
          }
        ]
      }
    ],
    otherServiceInformations: [
      {
        id: 'OT13',
        airlineCode: '6X',
        freetext: 'ARRIVAL AIRPORT LHR'
      }
    ],
    specialKeywords: [
      {
        id: 'OT14',
        keyword: 'JTOP',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'SK FREETEXT FOR CHD PASSENGERS []',
        flightIds: [
          'ST1'
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT7',
        code: 'HBAG',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL 3KG 0PC',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT32',
        code: 'BAGA',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL23KG',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT33',
        code: 'BAGA',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL23KG',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST2'
        ]
      }
    ],
    paymentRecords: [
      {
        id: 'FPT8',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            },
            amount: {
              value: 90,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        serviceItemIds: [
          'TSM8'
        ]
      },
      {
        id: 'FPT25',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            },
            amount: {
              value: 26_110,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1',
          'ST2'
        ]
      }
    ]
  },
  dictionaries: {
    location: {
      NCE: {
        type: 'airport',
        airportName: 'COTE D AZUR',
        cityCode: 'NCE',
        cityName: 'NICE',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      },
      LHR: {
        type: 'airport',
        airportName: 'HEATHROW',
        cityCode: 'LON',
        countryCode: 'GB',
        timeZone: 'UTC+0100'
      },
      LON: {
        type: 'city',
        cityCode: 'LON',
        cityName: 'LONDON',
        countryCode: 'GB',
        timeZone: 'UTC+0100'
      }
    },
    country: {
      GB: 'UNITED KINGDOM',
      FR: 'FRANCE'
    },
    airline: {
      '6X': 'AMADEUS SIX'
    },
    aircraft: {
      320: 'AIRBUS A320',
      343: 'AIRBUS A340-300'
    },
    flight: {
      ST2: {
        marketingAirlineCode: '6X',
        operatingAirlineCode: '6X',
        marketingFlightNumber: 404,
        operatingAirlineFlightNumber: 404,
        departure: {
          locationCode: 'LHR',
          dateTime: new utils.DateTime(todayPlusNdays('16:00', 3))
        },
        arrival: {
          locationCode: 'NCE',
          dateTime: new utils.DateTime(todayPlusNdays('18:00', 3))
        },
        aircraftCode: 320,
        duration: 3600,
        isOpenSegment: false,
        secureFlightIndicator: false,
        flightStatus: 'scheduled'
      },
      ST1: {
        marketingAirlineCode: '6X',
        operatingAirlineCode: '6X',
        marketingFlightNumber: 9891,
        operatingAirlineFlightNumber: 9891,
        departure: {
          locationCode: 'NCE',
          dateTime: new utils.DateTime(todayPlusNdays('08:00', 1)),
          terminal: 1
        },
        arrival: {
          locationCode: 'LHR',
          dateTime: new utils.DateTime(todayPlusNdays('09:00', 1)),
          terminal: 5
        },
        aircraftCode: 343,
        duration: 7200,
        isOpenSegment: false,
        secureFlightIndicator: false,
        flightStatus: 'scheduled'
      }
    },
    tax: {
      FRTI: 'FRTI',
      O4: 'O4',
      QX: 'QX',
      IZEB: 'IZEB',
      FR: 'FR',
      UB: 'UB',
      QXAP: 'QXAP',
      IZ: 'IZ',
      O4VC: 'O4VC',
      UBAS: 'UBAS',
      GB: 'GB',
      FRSE: 'FRSE',
      GBAD: 'GBAD'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      }
    }
  }
};

export const retrieveOrderMockEligibleToRefundWithInsurancesAndServices = {
  data: {
    id: 'K26CZX',
    creationPointOfSale: {
      pointOfSaleId: 'NCE6X0100',
      countryCode: 'FR'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('12:07', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('12:54', -1)),
    isGroupBooking: false,
    air: {
      prices: {
        unitPrices: [
          {
            travelerIds: [
              'PT2'
            ],
            prices: [
              {
                base: {
                  value: 20_000,
                  currencyCode: 'EUR'
                },
                total: {
                  value: 26_110,
                  currencyCode: 'EUR'
                },
                taxes: [
                  {
                    value: 463,
                    currencyCode: 'EUR',
                    code: 'FRSE'
                  },
                  {
                    value: 785,
                    currencyCode: 'EUR',
                    code: 'FRTI'
                  },
                  {
                    value: 113,
                    currencyCode: 'EUR',
                    code: 'IZEB'
                  },
                  {
                    value: 150,
                    currencyCode: 'EUR',
                    code: 'O4VC'
                  },
                  {
                    value: 725,
                    currencyCode: 'EUR',
                    code: 'QXAP'
                  },
                  {
                    value: 1497,
                    currencyCode: 'EUR',
                    code: 'GBAD'
                  },
                  {
                    value: 2377,
                    currencyCode: 'EUR',
                    code: 'UBAS'
                  }
                ],
                totalTaxes: {
                  value: 6110,
                  currencyCode: 'EUR'
                }
              }
            ]
          }
        ],
        totalPrices: [
          {
            base: {
              value: 20_000,
              currencyCode: 'EUR'
            },
            total: {
              value: 26_110,
              currencyCode: 'EUR'
            },
            totalTaxes: {
              value: 6110,
              currencyCode: 'EUR'
            }
          }
        ]
      },
      bounds: [
        {
          airBoundId: 1,
          originLocationCode: 'NCE',
          destinationLocationCode: 'LHR',
          flights: [
            {
              id: 'ST1',
              cabin: 'eco',
              bookingClass: 'B',
              statusCode: 'HK',
              fareFamilyCode: '-ALL-'
            }
          ],
          duration: 7200
        },
        {
          airBoundId: 2,
          originLocationCode: 'LHR',
          destinationLocationCode: 'NCE',
          flights: [
            {
              id: 'ST2',
              cabin: 'eco',
              bookingClass: 'B',
              statusCode: 'HK',
              fareFamilyCode: '-ALL-'
            }
          ],
          duration: 3600
        }
      ],
      freeCheckedBaggageAllowanceItems: [
        {
          details: {
            type: 'weight',
            weightUnit: 'kilogram',
            quantity: 23
          },
          flightIds: [
            'ST1'
          ],
          travelerIds: [
            'PT2'
          ]
        },
        {
          details: {
            type: 'weight',
            weightUnit: 'kilogram',
            quantity: 23
          },
          flightIds: [
            'ST2'
          ],
          travelerIds: [
            'PT2'
          ]
        }
      ]
    },
    services: [
      {
        id: 'TSM8',
        descriptions: [
          {
            type: 'shortText',
            content: 'HBAG'
          },
          {
            type: 'longText',
            content: 'HOCKEY EQUIPMENT'
          }
        ],
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        parameters: [
          {
            code: 'TEXT',
            value: 'TTL 3KG 0PC'
          }
        ],
        travelerId: 'PT2',
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: {
                    value: 90,
                    currencyCode: 'EUR'
                  },
                  total: {
                    value: 90,
                    currencyCode: 'EUR'
                  }
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: {
                value: 90,
                currencyCode: 'EUR'
              },
              total: {
                value: 90,
                currencyCode: 'EUR'
              }
            }
          ]
        }
      },
      {
        id: 'OT32',
        descriptions: [
          {
            type: 'shortText',
            content: 'BAGA'
          }
        ],
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        parameters: [
          {
            code: 'TEXT',
            value: 'TTL23KG'
          }
        ],
        travelerId: 'PT2'
      },
      {
        id: 'OT33',
        descriptions: [
          {
            type: 'shortText',
            content: 'BAGA'
          }
        ],
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'HK',
        parameters: [
          {
            code: 'TEXT',
            value: 'TTL23KG'
          }
        ],
        travelerId: 'PT2'
      }
    ],
    insurances: [
      {
        insuranceProviderCode: 'TGC',
        countryCode: 'GB',
        product: {
          code: 'INS_1'
        },
        prices: {
          totalPrice: {
            total: 500,
            currencyCode: 'EUR',
            totalTaxes: 0,
            currency: {
              name: 'EUR',
              decimalPlaces: 2
            }
          }
        },
        id: 'INS_1',
        confirmationNumber: '012345',
        statusCode: 'HK',
        insuranceProvider: {},
        status: {
          name: 'Confirmed'
        }
      }
    ],
    travelers: [
      {
        passengerTypeCode: 'ADT',
        id: 'PT2',
        names: [
          {
            firstName: 'Islee',
            lastName: 'Myname',
            nameType: 'universal',
            isPreferred: true
          }
        ],
        dateOfBirth: '1990-01-01'
      }
    ],
    contacts: [
      {
        id: 'OT3',
        travelerIds: [
          'PT2'
        ],
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: '3399998888-M'
      },
      {
        id: 'OT4',
        travelerIds: [
          'PT2'
        ],
        category: 'personal',
        contactType: 'Email',
        purpose: 'standard',
        address: 'TEST@AMADEUS.COM'
      }
    ],
    travelDocuments: [
      {
        flightIds: [
          'ST1',
          'ST2'
        ],
        travelerIds: [
          'PT2'
        ],
        id: 1_722_400_159_180,
        documentType: 'eticket',
        price: {
          base: 20_000,
          total: 26_110,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 463,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 785,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 113,
              currencyCode: 'EUR',
              code: 'IZ'
            },
            {
              value: 150,
              currencyCode: 'EUR',
              code: 'O4'
            },
            {
              value: 725,
              currencyCode: 'EUR',
              code: 'QX'
            },
            {
              value: 1497,
              currencyCode: 'EUR',
              code: 'GB'
            },
            {
              value: 2377,
              currencyCode: 'EUR',
              code: 'UB'
            }
          ],
          totalTaxes: 6110
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'BRVRT',
            fareFamilyCode: '-ALL-',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: '6X',
              marketingFlightNumber: 9891,
              departure: {
                locationCode: 'NCE',
                dateTime: new utils.DateTime(todayPlusNdays('08:00', 0))
              },
              arrival: {
                locationCode: 'LHR',
                dateTime: new utils.DateTime(todayPlusNdays('09:00', -1))
              }
            }
          },
          {
            fareClass: 'BRVRT',
            fareFamilyCode: '-ALL-',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: '6X',
              marketingFlightNumber: 404,
              departure: {
                locationCode: 'LHR',
                dateTime: new utils.DateTime(todayPlusNdays('16:00', -1))
              },
              arrival: {
                locationCode: 'NCE',
                dateTime: new utils.DateTime(todayPlusNdays('18:00', 0))
              }
            }
          }
        ]
      },
      {
        serviceIds: [
          'TSM8'
        ],
        travelerIds: [
          'PT2'
        ],
        id: 1_728_200_024_934,
        documentType: 'services',
        price: {
          base: 90,
          total: 90,
          currencyCode: 'EUR'
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            }
          }
        ]
      }
    ],
    otherServiceInformations: [
      {
        id: 'OT13',
        airlineCode: '6X',
        freetext: 'ARRIVAL AIRPORT LHR'
      }
    ],
    specialKeywords: [
      {
        id: 'OT14',
        keyword: 'JTOP',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'SK FREETEXT FOR CHD PASSENGERS []',
        flightIds: [
          'ST1'
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT7',
        code: 'HBAG',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL 3KG 0PC',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT32',
        code: 'BAGA',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL23KG',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT33',
        code: 'BAGA',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL23KG',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST2'
        ]
      }
    ],
    paymentRecords: [
      {
        id: 'FPT8',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            },
            amount: {
              value: 90,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        serviceItemIds: [
          'TSM8'
        ]
      },
      {
        id: 'FPT25',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            },
            amount: {
              value: 26_110,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1',
          'ST2'
        ]
      }
    ]
  },
  dictionaries: {
    location: {
      NCE: {
        type: 'airport',
        airportName: 'COTE D AZUR',
        cityCode: 'NCE',
        cityName: 'NICE',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      },
      LHR: {
        type: 'airport',
        airportName: 'HEATHROW',
        cityCode: 'LON',
        countryCode: 'GB',
        timeZone: 'UTC+0100'
      },
      LON: {
        type: 'city',
        cityCode: 'LON',
        cityName: 'LONDON',
        countryCode: 'GB',
        timeZone: 'UTC+0100'
      }
    },
    country: {
      GB: 'UNITED KINGDOM',
      FR: 'FRANCE'
    },
    airline: {
      '6X': 'AMADEUS SIX'
    },
    aircraft: {
      320: 'AIRBUS A320',
      343: 'AIRBUS A340-300'
    },
    flight: {
      ST2: {
        marketingAirlineCode: '6X',
        operatingAirlineCode: '6X',
        marketingFlightNumber: 404,
        operatingAirlineFlightNumber: 404,
        departure: {
          locationCode: 'LHR',
          dateTime: new utils.DateTime(todayPlusNdays('16:00', 3))
        },
        arrival: {
          locationCode: 'NCE',
          dateTime: new utils.DateTime(todayPlusNdays('18:00', 3))
        },
        aircraftCode: 320,
        duration: 3600,
        isOpenSegment: false,
        secureFlightIndicator: false,
        flightStatus: 'scheduled'
      },
      ST1: {
        marketingAirlineCode: '6X',
        operatingAirlineCode: '6X',
        marketingFlightNumber: 9891,
        operatingAirlineFlightNumber: 9891,
        departure: {
          locationCode: 'NCE',
          dateTime: new utils.DateTime(todayPlusNdays('08:00', 1)),
          terminal: 1
        },
        arrival: {
          locationCode: 'LHR',
          dateTime: new utils.DateTime(todayPlusNdays('09:00', 1)),
          terminal: 5
        },
        aircraftCode: 343,
        duration: 7200,
        isOpenSegment: false,
        secureFlightIndicator: false,
        flightStatus: 'scheduled'
      }
    },
    tax: {
      FRTI: 'FRTI',
      O4: 'O4',
      QX: 'QX',
      IZEB: 'IZEB',
      FR: 'FR',
      UB: 'UB',
      QXAP: 'QXAP',
      IZ: 'IZ',
      O4VC: 'O4VC',
      UBAS: 'UBAS',
      GB: 'GB',
      FRSE: 'FRSE',
      GBAD: 'GBAD'
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      }
    }
  }
};

export const retrieveOrderMockEligibleToRefundWithoutServices = {
  data: {
    id: 'Q3EAEY',
    creationPointOfSale: {
      pointOfSaleId: 'STOSK08VR',
      countryCode: 'SE'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('08:17', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('11:47', -1)),
    isGroupBooking: false,
    air: {
      prices: {
        unitPrices: [
          {
            travelerIds: [
              'PT1',
              'PT2'
            ],
            prices: [
              {
                base: {
                  value: 12_593,
                  currencyCode: 'SEK'
                },
                total: {
                  value: 14_361,
                  currencyCode: 'SEK'
                },
                taxes: [
                  {
                    value: 1200,
                    currencyCode: 'SEK',
                    code: 'YQAC'
                  },
                  {
                    value: 260,
                    currencyCode: 'SEK',
                    code: 'LJAV'
                  },
                  {
                    value: 161,
                    currencyCode: 'SEK',
                    code: 'YAAD'
                  },
                  {
                    value: 35,
                    currencyCode: 'SEK',
                    code: 'XACO'
                  },
                  {
                    value: 61,
                    currencyCode: 'SEK',
                    code: 'XYCR'
                  },
                  {
                    value: 51,
                    currencyCode: 'SEK',
                    code: 'YCAE'
                  }
                ],
                totalTaxes: {
                  value: 1768,
                  currencyCode: 'SEK'
                }
              }
            ]
          },
          {
            travelerIds: [
              'PT3'
            ],
            prices: [
              {
                base: {
                  value: 9445,
                  currencyCode: 'SEK'
                },
                total: {
                  value: 11_213,
                  currencyCode: 'SEK'
                },
                taxes: [
                  {
                    value: 1200,
                    currencyCode: 'SEK',
                    code: 'YQAC'
                  },
                  {
                    value: 260,
                    currencyCode: 'SEK',
                    code: 'LJAV'
                  },
                  {
                    value: 161,
                    currencyCode: 'SEK',
                    code: 'YAAD'
                  },
                  {
                    value: 35,
                    currencyCode: 'SEK',
                    code: 'XACO'
                  },
                  {
                    value: 61,
                    currencyCode: 'SEK',
                    code: 'XYCR'
                  },
                  {
                    value: 51,
                    currencyCode: 'SEK',
                    code: 'YCAE'
                  }
                ],
                totalTaxes: {
                  value: 1768,
                  currencyCode: 'SEK'
                }
              }
            ]
          }
        ],
        totalPrices: [
          {
            base: {
              value: 34_631,
              currencyCode: 'SEK'
            },
            total: {
              value: 39_935,
              currencyCode: 'SEK'
            },
            totalTaxes: {
              value: 5304,
              currencyCode: 'SEK'
            }
          }
        ]
      },
      bounds: [
        {
          airBoundId: '1',
          originLocationCode: 'ARN',
          destinationLocationCode: 'EWR',
          flights: [
            {
              id: 'ST1',
              cabin: 'ecoPremium',
              bookingClass: 'Y',
              statusCode: 'HK'
            }
          ],
          duration: 31_800
        }
      ],
      freeCheckedBaggageAllowanceItems: [
        {
          details: {
            type: 'piece',
            quantity: 2
          },
          flightIds: [
            'ST1'
          ],
          travelerIds: [
            'PT1',
            'PT2'
          ]
        },
        {
          details: {
            type: 'piece',
            quantity: 2
          },
          flightIds: [
            'ST1'
          ],
          travelerIds: [
            'PT3'
          ]
        }
      ]
    },
    travelers: [
      {
        id: 'PT1',
        names: [
          {
            firstName: 'A George',
            lastName: 'John',
            title: 'MR',
            nameType: 'universal',
            isPreferred: true
          }
        ],
        regulatoryDetails: [
          {
            id: 'OT17',
            flightIds: [
              'ST1'
            ],
            regulatoryApisType: 'ApisDetailRegulatoryDocument',
            regulatoryDocument: {
              name: {
                nameType: 'universal'
              }
            }
          }
        ]
      },
      {
        id: 'PT2',
        names: [
          {
            firstName: 'A Pepa',
            lastName: 'John',
            title: 'MRS',
            nameType: 'universal',
            isPreferred: true
          }
        ],
        regulatoryDetails: [
          {
            id: 'OT16',
            flightIds: [
              'ST1'
            ],
            regulatoryApisType: 'ApisDetailRegulatoryDocument',
            regulatoryDocument: {
              name: {
                nameType: 'universal'
              }
            }
          }
        ]
      },
      {
        passengerTypeCode: 'CHD',
        id: 'PT3',
        names: [
          {
            firstName: 'Peter',
            lastName: 'Wolff',
            nameType: 'universal',
            isPreferred: true
          }
        ],
        dateOfBirth: '2011-12-05',
        regulatoryDetails: [
          {
            id: 'OT15',
            flightIds: [
              'ST1'
            ],
            regulatoryApisType: 'ApisDetailRegulatoryDocument',
            regulatoryDocument: {
              name: {
                nameType: 'universal'
              }
            }
          }
        ]
      }
    ],
    contacts: [
      {
        id: 'OT8',
        category: 'personal',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        countryPhoneExtension: '+44',
        number: '0141 22001453'
      },
      {
        id: 'OT9',
        category: 'personal',
        contactType: 'Email',
        purpose: 'standard',
        address: 'TESTER@AMADEUS.COM'
      }
    ],
    travelDocuments: [
      {
        flightIds: [
          'ST1'
        ],
        travelerIds: [
          'PT3'
        ],
        id: '1172457148335',
        documentType: 'eticket',
        price: {
          base: 9445,
          total: 11_213,
          currencyCode: 'SEK',
          taxes: [
            {
              value: 1200,
              currencyCode: 'SEK',
              code: 'YQ'
            },
            {
              value: 260,
              currencyCode: 'SEK',
              code: 'LJ'
            },
            {
              value: 161,
              currencyCode: 'SEK',
              code: 'YA'
            },
            {
              value: 35,
              currencyCode: 'SEK',
              code: 'XA'
            },
            {
              value: 61,
              currencyCode: 'SEK',
              code: 'XY'
            },
            {
              value: 51,
              currencyCode: 'SEK',
              code: 'YC'
            }
          ],
          totalTaxes: 1768
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1122'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YSEOW/CH',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'SK',
              marketingFlightNumber: '903',
              departure: {
                locationCode: 'ARN',
                dateTime: new utils.DateTime(todayPlusNdays('10:45', 0))
              },
              arrival: {
                locationCode: 'EWR'
              }
            }
          }
        ]
      },
      {
        flightIds: [
          'ST1'
        ],
        travelerIds: [
          'PT2'
        ],
        id: '1172457148334',
        documentType: 'eticket',
        price: {
          base: 12_593,
          total: 14_361,
          currencyCode: 'SEK',
          taxes: [
            {
              value: 1200,
              currencyCode: 'SEK',
              code: 'YQ'
            },
            {
              value: 260,
              currencyCode: 'SEK',
              code: 'LJ'
            },
            {
              value: 161,
              currencyCode: 'SEK',
              code: 'YA'
            },
            {
              value: 35,
              currencyCode: 'SEK',
              code: 'XA'
            },
            {
              value: 61,
              currencyCode: 'SEK',
              code: 'XY'
            },
            {
              value: 51,
              currencyCode: 'SEK',
              code: 'YC'
            }
          ],
          totalTaxes: 1768
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1122'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YSEOW',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'SK',
              marketingFlightNumber: '903',
              departure: {
                locationCode: 'ARN',
                dateTime: new utils.DateTime(todayPlusNdays('10:45', 0))
              },
              arrival: {
                locationCode: 'EWR'
              }
            }
          }
        ]
      },
      {
        flightIds: [
          'ST1'
        ],
        travelerIds: [
          'PT1'
        ],
        id: '1172457148333',
        documentType: 'eticket',
        price: {
          base: 12_593,
          total: 14_361,
          currencyCode: 'SEK',
          taxes: [
            {
              value: 1200,
              currencyCode: 'SEK',
              code: 'YQ'
            },
            {
              value: 260,
              currencyCode: 'SEK',
              code: 'LJ'
            },
            {
              value: 161,
              currencyCode: 'SEK',
              code: 'YA'
            },
            {
              value: 35,
              currencyCode: 'SEK',
              code: 'XA'
            },
            {
              value: 61,
              currencyCode: 'SEK',
              code: 'XY'
            },
            {
              value: 51,
              currencyCode: 'SEK',
              code: 'YC'
            }
          ],
          totalTaxes: 1768
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1122'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'YSEOW',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: 'SK',
              marketingFlightNumber: '903',
              departure: {
                locationCode: 'ARN',
                dateTime: new utils.DateTime(todayPlusNdays('10:45', 0))
              },
              arrival: {
                locationCode: 'EWR'
              }
            }
          }
        ]
      },
      {
        serviceIds: [
          'TSM22'
        ],
        travelerIds: [
          'PT3'
        ],
        id: '1174561102654',
        documentType: 'services',
        price: {
          base: 269,
          total: 269,
          currencyCode: 'SEK'
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1122'
            }
          }
        ]
      }
    ],
    remarks: [
      {
        id: 'OT5',
        remarkType: 'GeneralRemark',
        freetext: 'NOTIFY PASSENGER PRIOR TO TICKET PURCHASE &amp; CHECK-IN: FEDERAL LAWS FORBID THE CARRIAGE OF HAZARDOUS MATERIALS - GGAMAUSHAZ',
        flightIds: [
          'ST1'
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT4',
        code: 'CHLD',
        airlineCode: 'SK',
        statusCode: 'HK',
        quantity: 1,
        freetext: '05DEC11',
        travelerIds: [
          'PT3'
        ]
      },
      {
        id: 'OT15',
        code: 'DOCS',
        airlineCode: 'SK',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'P/GBR/012345778/GBR/30JUN73/M/14APR09/WOLF/PETER/H',
        travelerIds: [
          'PT3'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT16',
        code: 'DOCS',
        airlineCode: 'SK',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'P/GBR/012345978/GBR/30JUN17/M/14APR09/JOHN/A PEPA/H',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT17',
        code: 'DOCS',
        airlineCode: 'SK',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'P/GBR/012345978/GBR/30JUN17/M/14APR09/JOHN/A GEORGE/H',
        travelerIds: [
          'PT1'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT21',
        code: 'LOUG',
        airlineCode: 'SK',
        statusCode: 'HK',
        quantity: 1,
        travelerIds: [
          'PT3'
        ],
        flightIds: [
          'ST1'
        ]
      }
    ],
    paymentRecords: [
      {
        id: 'FPT6',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1122'
            },
            amount: {
              value: 11_213,
              currencyCode: 'SEK'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: [
          'PT3'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'FPT22',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1122'
            },
            amount: {
              value: 269,
              currencyCode: 'SEK'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        serviceItemIds: [
          'TSM22'
        ]
      },
      {
        id: 'FPT25',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX9999',
              expiryDate: '1122'
            },
            amount: {
              value: 14_361,
              currencyCode: 'SEK'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: [
          'PT1',
          'PT2'
        ],
        flightIds: [
          'ST1'
        ]
      }
    ]
  },
  dictionaries: {
    location: {
      EWR: {
        type: 'airport',
        airportName: 'NEWARK LIBERTY INTL',
        cityCode: 'NYC',
        stateCode: 'NJ',
        countryCode: 'US',
        timeZone: 'UTC-0400'
      },
      NYC: {
        type: 'city',
        cityCode: 'NYC',
        cityName: 'NEW YORK',
        stateCode: 'NY',
        countryCode: 'US',
        timeZone: 'UTC-0400'
      },
      ARN: {
        type: 'airport',
        airportName: 'ARLANDA',
        cityCode: 'STO',
        countryCode: 'SE',
        timeZone: 'UTC+0200'
      },
      STO: {
        type: 'city',
        cityCode: 'STO',
        cityName: 'STOCKHOLM',
        countryCode: 'SE',
        timeZone: 'UTC+0200'
      }
    },
    country: {
      SE: 'SWEDEN',
      US: 'UNITED STATES OF AMERICA'
    },
    airline: {
      SK: 'SCANDINAVIAN AIRLINES'
    },
    aircraft: {
      333: 'AIRBUS A330-300'
    },
    flight: {
      ST1: {
        marketingAirlineCode: 'SK',
        operatingAirlineCode: 'SK',
        marketingFlightNumber: '903',
        operatingAirlineFlightNumber: '903',
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('10:45', 1)),
          terminal: '5'
        },
        arrival: {
          locationCode: 'EWR',
          dateTime: new utils.DateTime(todayPlusNdays('13:35', 1)),
          terminal: 'B'
        },
        aircraftCode: '333',
        duration: 31_800,
        isOpenSegment: false,
        secureFlightIndicator: true,
        meals: {
          bookingClass: 'Y',
          mealCodes: [
            'M'
          ]
        },
        flightStatus: 'scheduled'
      }
    },
    tax: {
      LJAV: 'LJAV',
      XY: 'XY',
      YAAD: 'YAAD',
      YQAC: 'YQAC',
      YCAE: 'YCAE',
      YQ: 'YQ',
      YA: 'YA',
      XYCR: 'XYCR',
      XA: 'XA',
      YC: 'YC',
      XACO: 'XACO',
      LJ: 'LJ'
    },
    currency: {
      SEK: {
        name: 'SWEDISH KRONA',
        decimalPlaces: 0
      }
    },
    specialServiceRequest: {
      CHLD: {
        name: 'CHILD PASSENGER INFORMATION'
      },
      DOCS: {
        name: 'PASSENGER/CREW PRIMARY TRAVEL DOCUMENT INFO'
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      }
    },
    meal: {
      M: 'MEAL (NON-SPECIFIC)'
    }
  }
};

export const retrieveOrderMockEligibleToRefundOnVoucher: OrderReply = {
  data: createOrder({
    template: {
      id: 'ABC123',
      air: createOrderAirItem({
        template: {
          bounds: [
            createBound({
              template: {
                airBoundId: '1',
                flights: [
                  createFlightItem({
                    template: {
                      statusCode: 'HK'
                    }
                  })
                ]
              }
            })
          ]
        }
      }),
      travelers: [
        createTraveler({
          template: {
            names: [createName()]
          }
        })
      ],
      paymentRecords: [createPaymentRecord({
        template: {
          paymentTransactions: [
            {
              paymentMethod: createPaymentCard({
                template: {
                  cardNumber: 'xxxxxxxxxxxx9999'
                }
              }),
              amount: {
                value: 200_000,
                currencyCode: 'EUR',
                currency: {
                  name: 'EUR',
                  decimalPlaces: 2
                }
              }
            }
          ]
        }
      })],
      travelDocuments: [
        {
          flightIds: [
            'ST1'
          ],
          travelerIds: [
            'PT3'
          ],
          id: '1172457148335',
          documentType: 'eticket',
          fareInfos: [
            {
              fareClass: 'YSEOW/CH',
              couponStatus: 'open',
              flight: {
                marketingAirline: 'AMADEUS SIX X',
                marketingAirlineCode: '6X',
                marketingFlightNumber: '9891',
                departure: {
                  locationCode: 'NCE',
                  dateTime: new utils.DateTime(todayPlusNdays('08:00', 1))
                },
                arrival: {
                  locationCode: 'LHR',
                  dateTime: new utils.DateTime(todayPlusNdays('09:00', 1))
                }
              }
            }
          ]
        }
      ]
    }
  })
};

export const retrieveOrderMockEligibleToRefundWithServicesAndDetailledAmounts = {
  data: {
    id: 'OQJTFY',
    creationPointOfSale: {
      pointOfSaleId: 'NCE6X0100',
      countryCode: 'FR'
    },
    creationDateTime: new utils.DateTime(todayPlusNdays('12:07', -1)),
    lastModificationDateTime: new utils.DateTime(todayPlusNdays('12:54', -1)),
    isGroupBooking: false,
    air: {
      prices: {
        unitPrices: [
          {
            travelerIds: [
              'PT2'
            ],
            prices: [
              {
                base: {
                  value: 20_000,
                  currencyCode: 'EUR'
                },
                total: {
                  value: 26_110,
                  currencyCode: 'EUR'
                },
                taxes: [
                  {
                    value: 463,
                    currencyCode: 'EUR',
                    code: 'FRSE'
                  },
                  {
                    value: 785,
                    currencyCode: 'EUR',
                    code: 'FRTI'
                  },
                  {
                    value: 113,
                    currencyCode: 'EUR',
                    code: 'IZEB'
                  },
                  {
                    value: 150,
                    currencyCode: 'EUR',
                    code: 'O4VC'
                  },
                  {
                    value: 725,
                    currencyCode: 'EUR',
                    code: 'QXAP'
                  },
                  {
                    value: 1497,
                    currencyCode: 'EUR',
                    code: 'GBAD'
                  },
                  {
                    value: 2377,
                    currencyCode: 'EUR',
                    code: 'UBAS'
                  }
                ],
                totalTaxes: {
                  value: 6110,
                  currencyCode: 'EUR'
                }
              }
            ]
          }
        ],
        totalPrices: [
          {
            base: {
              value: 20_000,
              currencyCode: 'EUR'
            },
            total: {
              value: 26_110,
              currencyCode: 'EUR'
            },
            totalTaxes: {
              value: 6110,
              currencyCode: 'EUR'
            }
          }
        ]
      },
      bounds: [
        {
          airBoundId: 1,
          originLocationCode: 'NCE',
          destinationLocationCode: 'LHR',
          flights: [
            {
              id: 'ST1',
              cabin: 'eco',
              bookingClass: 'B',
              statusCode: 'HK',
              fareFamilyCode: '-ALL-'
            }
          ],
          duration: 7200
        },
        {
          airBoundId: 2,
          originLocationCode: 'LHR',
          destinationLocationCode: 'NCE',
          flights: [
            {
              id: 'ST2',
              cabin: 'eco',
              bookingClass: 'B',
              statusCode: 'HK',
              fareFamilyCode: '-ALL-'
            }
          ],
          duration: 3600
        }
      ],
      freeCheckedBaggageAllowanceItems: [
        {
          details: {
            type: 'weight',
            weightUnit: 'kilogram',
            quantity: 23
          },
          flightIds: [
            'ST1'
          ],
          travelerIds: [
            'PT2'
          ]
        },
        {
          details: {
            type: 'weight',
            weightUnit: 'kilogram',
            quantity: 23
          },
          flightIds: [
            'ST2'
          ],
          travelerIds: [
            'PT2'
          ]
        }
      ]
    },
    services: [
      {
        id: 'TSM8',
        descriptions: [
          {
            type: 'shortText',
            content: 'HBAG'
          },
          {
            type: 'longText',
            content: 'HOCKEY EQUIPMENT'
          }
        ],
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        parameters: [
          {
            code: 'TEXT',
            value: 'TTL 3KG 0PC'
          }
        ],
        travelerId: 'PT2',
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: {
                    value: 90,
                    currencyCode: 'EUR'
                  },
                  total: {
                    value: 90,
                    currencyCode: 'EUR'
                  }
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: {
                value: 90,
                currencyCode: 'EUR'
              },
              total: {
                value: 90,
                currencyCode: 'EUR'
              }
            }
          ]
        }
      },
      {
        id: 'OT32',
        descriptions: [
          {
            type: 'shortText',
            content: 'BAGA'
          }
        ],
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        parameters: [
          {
            code: 'TEXT',
            value: 'TTL23KG'
          }
        ],
        travelerId: 'PT2'
      },
      {
        id: 'OT33',
        descriptions: [
          {
            type: 'shortText',
            content: 'BAGA'
          }
        ],
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'HK',
        parameters: [
          {
            code: 'TEXT',
            value: 'TTL23KG'
          }
        ],
        travelerId: 'PT2'
      }
    ],
    travelers: [
      {
        passengerTypeCode: 'ADT',
        id: 'PT2',
        names: [
          {
            firstName: 'Islee',
            lastName: 'Myname',
            nameType: 'universal',
            isPreferred: true
          }
        ],
        dateOfBirth: '1990-01-01'
      }
    ],
    contacts: [
      {
        id: 'OT3',
        travelerIds: [
          'PT2'
        ],
        category: 'other',
        contactType: 'Phone',
        deviceType: 'landline',
        purpose: 'standard',
        number: '3399998888-M'
      },
      {
        id: 'OT4',
        travelerIds: [
          'PT2'
        ],
        category: 'personal',
        contactType: 'Email',
        purpose: 'standard',
        address: 'TEST@AMADEUS.COM'
      }
    ],
    travelDocuments: [
      {
        flightIds: [
          'ST1',
          'ST2'
        ],
        travelerIds: [
          'PT2'
        ],
        id: 1_722_400_159_180,
        documentType: 'eticket',
        price: {
          base: 20_000,
          total: 26_110,
          currencyCode: 'EUR',
          taxes: [
            {
              value: 463,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 785,
              currencyCode: 'EUR',
              code: 'FR'
            },
            {
              value: 113,
              currencyCode: 'EUR',
              code: 'IZ'
            },
            {
              value: 150,
              currencyCode: 'EUR',
              code: 'O4'
            },
            {
              value: 725,
              currencyCode: 'EUR',
              code: 'QX'
            },
            {
              value: 1497,
              currencyCode: 'EUR',
              code: 'GB'
            },
            {
              value: 2377,
              currencyCode: 'EUR',
              code: 'UB'
            }
          ],
          totalTaxes: 6110
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            }
          }
        ],
        fareInfos: [
          {
            fareClass: 'BRVRT',
            fareFamilyCode: '-ALL-',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: '6X',
              marketingFlightNumber: 9891,
              departure: {
                locationCode: 'NCE',
                dateTime: new utils.DateTime(todayPlusNdays('08:00', 1))
              },
              arrival: {
                locationCode: 'LHR',
                dateTime: new utils.DateTime(todayPlusNdays('09:00', 1))
              }
            }
          },
          {
            fareClass: 'BRVRT',
            fareFamilyCode: '-ALL-',
            couponStatus: 'open',
            flight: {
              marketingAirlineCode: '6X',
              marketingFlightNumber: 404,
              departure: {
                locationCode: 'LHR',
                dateTime: new utils.DateTime(todayPlusNdays('16:00', 2))
              },
              arrival: {
                locationCode: 'NCE',
                dateTime: new utils.DateTime(todayPlusNdays('18:00', 2))
              }
            }
          }
        ]
      },
      {
        serviceIds: [
          'TSM8'
        ],
        travelerIds: [
          'PT2'
        ],
        id: 1_728_200_024_934,
        documentType: 'services',
        price: {
          base: 90,
          total: 90,
          currencyCode: 'EUR'
        },
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            }
          }
        ]
      }
    ],
    otherServiceInformations: [
      {
        id: 'OT13',
        airlineCode: '6X',
        freetext: 'ARRIVAL AIRPORT LHR'
      }
    ],
    specialKeywords: [
      {
        id: 'OT14',
        keyword: 'JTOP',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'SK FREETEXT FOR CHD PASSENGERS []',
        flightIds: [
          'ST1'
        ]
      }
    ],
    specialServiceRequests: [
      {
        id: 'OT7',
        code: 'HBAG',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL 3KG 0PC',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT32',
        code: 'BAGA',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL23KG',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1'
        ]
      },
      {
        id: 'OT33',
        code: 'BAGA',
        airlineCode: '6X',
        statusCode: 'HK',
        quantity: 1,
        freetext: 'TTL23KG',
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST2'
        ]
      }
    ],
    paymentRecords: [
      {
        id: 'FPT8',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            },
            amount: {
              value: 90,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        serviceItemIds: [
          'TSM8'
        ]
      },
      {
        id: 'FPT25',
        paymentTransactions: [
          {
            paymentMethod: {
              paymentType: 'PaymentCard',
              vendorCode: 'VI',
              cardNumber: 'XXXXXXXXXXXX0004',
              expiryDate: 1228,
              holderName: 'etvtst'
            },
            amount: {
              value: 26_110,
              currencyCode: 'EUR'
            },
            authorization: {
              approvalCode: 'APS1OK'
            }
          }
        ],
        travelerIds: [
          'PT2'
        ],
        flightIds: [
          'ST1',
          'ST2'
        ]
      }
    ]
  },
  dictionaries: {
    location: {
      NCE: {
        type: 'airport',
        airportName: 'COTE D AZUR',
        cityCode: 'NCE',
        cityName: 'NICE',
        countryCode: 'FR',
        timeZone: 'UTC+0200'
      },
      LHR: {
        type: 'airport',
        airportName: 'HEATHROW',
        cityCode: 'LON',
        countryCode: 'GB',
        timeZone: 'UTC+0100'
      },
      LON: {
        type: 'city',
        cityCode: 'LON',
        cityName: 'LONDON',
        countryCode: 'GB',
        timeZone: 'UTC+0100'
      }
    },
    country: {
      GB: 'UNITED KINGDOM',
      FR: 'FRANCE'
    },
    airline: {
      '6X': 'AMADEUS SIX'
    },
    aircraft: {
      320: 'AIRBUS A320',
      343: 'AIRBUS A340-300'
    },
    flight: {
      ST2: {
        marketingAirlineCode: '6X',
        operatingAirlineCode: '6X',
        marketingFlightNumber: 404,
        operatingAirlineFlightNumber: 404,
        departure: {
          locationCode: 'LHR',
          dateTime: new utils.DateTime(todayPlusNdays('16:00', 4))
        },
        arrival: {
          locationCode: 'NCE',
          dateTime: new utils.DateTime(todayPlusNdays('18:00', 4))
        },
        aircraftCode: 320,
        duration: 3600,
        isOpenSegment: false,
        secureFlightIndicator: false,
        flightStatus: 'scheduled'
      },
      ST1: {
        marketingAirlineCode: '6X',
        operatingAirlineCode: '6X',
        marketingFlightNumber: 9891,
        operatingAirlineFlightNumber: 9891,
        departure: {
          locationCode: 'NCE',
          dateTime: new utils.DateTime(todayPlusNdays('08:00', 1)),
          terminal: 1
        },
        arrival: {
          locationCode: 'LHR',
          dateTime: new utils.DateTime(todayPlusNdays('09:00', 1)),
          terminal: 5
        },
        aircraftCode: 343,
        duration: 7200,
        isOpenSegment: false,
        secureFlightIndicator: false,
        flightStatus: 'scheduled'
      }
    },
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    },
    bookingStatus: {
      HK: {
        name: 'Holding confirmed'
      }
    }
  }
};

export const retrieveOrderMockEligibleToVoluntaryRefund: OrderReply = ({
  data: createOrder({
    template: {
      id: 'TBEVQ7',
      isGroupBooking: false,
      air: createOrderAirItem({
        template: {
          bounds: [
            createBound({
              template: {
                airBoundId: '1',
                flights: [
                  createFlightItem({
                    template: {
                      statusCode: 'HK'
                    }
                  })
                ]
              }
            })
          ],
          prices: createMultiCurrencyAirPricingRecords({
            template: {
              unitPrices: [
                createMultiCurrencyUnitPrice({
                  template: {
                    travelerIds: ['PT2'],
                    prices: [
                      {
                        base: createAmount({
                          template: {
                            value: 45_700
                          }
                        }),
                        total: createAmount({
                          template: {
                            value: 51_131
                          }
                        }),
                        taxes: [
                          {
                            ...taxTemplate,
                            value: 473,
                            code: 'FRSE'
                          },
                          {
                            ...taxTemplate,
                            value: 820,
                            code: 'FRTI'
                          },
                          {
                            ...taxTemplate,
                            value: 1127,
                            code: 'IZEB'
                          },
                          {
                            ...taxTemplate,
                            value: 900,
                            code: 'O4VC'
                          },
                          {
                            ...taxTemplate,
                            value: 637,
                            code: 'QWLO'
                          }
                        ],
                        totalTaxes: createAmount({
                          template: {
                            value: 3957
                          }
                        }),
                        fees: [
                          {
                            ...createAmount({
                              template: {
                                value: 1474
                              }
                            }),
                            nature: 'ticketing'
                          }
                        ],
                        totalFees: createAmount({
                          template: {
                            value: 1474
                          }
                        })
                      }
                    ]
                  }
                })
              ],
              totalPrices: [
                {
                  base: createAmount({
                    template: {
                      value: 45_700
                    }
                  }),
                  total: createAmount({
                    template: {
                      value: 51_131
                    }
                  }),
                  totalTaxes: createAmount({
                    template: {
                      value: 3957
                    }
                  }),
                  totalFees: createAmount({
                    template: {
                      value: 1474
                    }
                  })
                }
              ]
            }
          })
        }
      }),
      travelers: [
        createTraveler({
          template: {
            passengerTypeCode: 'ADT',
            id: 'PT2',
            names: [createName()]
          }
        })
      ],
      paymentRecords: [createPaymentRecord({
        template: {
          paymentTransactions: [
            {
              paymentMethod: createPaymentCard({
                template: {
                  cardNumber: 'xxxxxxxxxxxx9999'
                }
              }),
              amount: createAmount({
                template: {
                  value: 51_131
                }
              })
            }
          ]
        }
      })],
      orderEligibilities: createOrderEligibilities({
        template: {
          cancelAndRefund: {
            isEligible: true
          }
        }
      }),
      travelDocuments: [
        {
          flightIds: [
            'ST1'
          ],
          travelerIds: [
            'PT3'
          ],
          id: '1172457148335',
          documentType: 'eticket',
          fareInfos: [
            {
              fareClass: 'YSEOW/CH',
              couponStatus: 'open',
              flight: {
                marketingAirline: 'AMADEUS SIX X',
                marketingAirlineCode: '6X',
                marketingFlightNumber: '9891',
                departure: {
                  locationCode: 'NCE',
                  dateTime: new utils.DateTime(todayPlusNdays('08:00', 1))
                },
                arrival: {
                  locationCode: 'LHR',
                  dateTime: new utils.DateTime(todayPlusNdays('09:00', 1))
                }
              }
            }
          ]
        }
      ]
    }
  })
});

export const retrieveOrderMockDisruptedOutboundWithLostServices = ({
  warnings: [
    {
      type: 'warning',
      code: '39610',
      title: 'LOST SERVICES'
    }
  ],
  data: createOrder({
    template: {
      id: 'SI9SIO',
      creationPointOfSale: {
        pointOfSaleId: 'PARAF08AA',
        countryCode: 'FR',
        country: 'FRANCE'
      },
      isGroupBooking: false,
      air: {
        bounds: [
          {
            airBoundId: '1',
            originLocationCode: 'NCE',
            destinationLocationCode: 'JFK',
            flights: [
              {
                id: 'ST1',
                cabin: 'business',
                bookingClass: 'J',
                statusCode: 'HK',
                connectionTime: 24_000,
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'AF',
                  marketingFlightNumber: '7711',
                  operatingAirlineFlightNumber: '7711',
                  departure: {
                    locationCode: 'NCE',
                    dateTime: new utils.DateTime(todayPlusNdays('06:10', 15)),
                    terminal: '2',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('04:10', 15)),
                    location: COTE_D_AZUR
                  },
                  arrival: {
                    locationCode: 'CDG',
                    dateTime: new utils.DateTime(todayPlusNdays('07:40', 15)),
                    terminal: '2F',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('05:40', 15)),
                    location: CHARLES_DE_GAULLE
                  },
                  aircraftCode: '319',
                  duration: 5400,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: false,
                  flightStatus: 'scheduled'
                },
                bookingStatus: {
                  name: 'Holding confirmed'
                }
              },
              {
                id: 'ST4',
                cabin: 'business',
                bookingClass: 'J',
                statusCode: 'TK',
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'AF',
                  marketingFlightNumber: '006',
                  operatingAirlineFlightNumber: '006',
                  departure: {
                    locationCode: 'CDG',
                    terminal: '1',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('12:20', 15)),
                    location: CHARLES_DE_GAULLE
                  },
                  arrival: {
                    locationCode: 'JFK',
                    dateTime: new utils.DateTime(todayPlusNdays('17:00', 15)),
                    terminal: '1',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('21:00', 15)),
                    location: JOHN_F_KENNEDY_INTL
                  },
                  aircraftCode: '77W',
                  duration: 31_200,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: true,
                  flightStatus: 'scheduled'
                },
                bookingStatus: {
                  name: 'Confirmed, timechange'
                }
              }
            ],
            duration: 60_600,
            disruptionStatus: {
              originalFlights: [
                {
                  id: 'ST1',
                  cabin: 'business',
                  bookingClass: 'J',
                  statusCode: 'HK',
                  connectionTime: 13_200,
                  flight: {
                    marketingAirlineCode: 'AF',
                    marketingAirline: 'AF',
                    operatingAirlineCode: 'AF',
                    marketingFlightNumber: '7711',
                    operatingAirlineFlightNumber: '7711',
                    departure: {
                      locationCode: 'NCE',
                      dateTime: new utils.DateTime(todayPlusNdays('06:10', 15)),
                      terminal: '2',
                      dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('04:10', 15)),
                      location: COTE_D_AZUR
                    },
                    arrival: {
                      locationCode: 'CDG',
                      dateTime: new utils.DateTime(todayPlusNdays('07:40', 15)),
                      terminal: '2F',
                      dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('05:40', 15)),
                      location: CHARLES_DE_GAULLE
                    },
                    aircraftCode: '319',
                    duration: 5400,
                    isOpenSegment: false,
                    isInformational: false,
                    secureFlightIndicator: false,
                    flightStatus: 'scheduled'
                  },
                  bookingStatus: {
                    name: 'Holding confirmed'
                  }
                },
                {
                  id: 'ST2',
                  cabin: 'business',
                  bookingClass: 'J',
                  statusCode: 'UN',
                  flight: {
                    marketingAirlineCode: 'AF',
                    marketingAirline: 'AF',
                    operatingAirlineCode: 'AF',
                    marketingFlightNumber: '014',
                    operatingAirlineFlightNumber: '014',
                    departure: {
                      locationCode: 'CDG',
                      dateTime: new utils.DateTime(todayPlusNdays('11:20', 15)),
                      terminal: '2E',
                      dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('09:20', 15)),
                      location: CHARLES_DE_GAULLE
                    },
                    arrival: {
                      locationCode: 'JFK',
                      dateTime: new utils.DateTime(todayPlusNdays('13:50', 15)),
                      terminal: '1',
                      dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('17:50', 15)),
                      location: JOHN_F_KENNEDY_INTL
                    },
                    aircraftCode: '77W',
                    duration: 30_600,
                    isOpenSegment: false,
                    isInformational: false,
                    secureFlightIndicator: true,
                    meals: {
                      bookingClass: 'J',
                      mealCodes: [
                        'M',
                        'S'
                      ]
                    },
                    flightStatus: 'cancelled'
                  },
                  bookingStatus: {
                    name: 'Unable, does not operate'
                  }
                }
              ],
              departure: {
                locationCode: 'NCE',
                sameAirport: true,
                sameCity: true,
                sameDay: true,
                deltaTime: 0,
                destinationLocation: COTE_D_AZUR
              },
              arrival: {
                locationCode: 'JFK',
                sameAirport: true,
                sameCity: true,
                sameDay: true,
                deltaTime: 11_400,
                destinationLocation: JOHN_F_KENNEDY_INTL
              },
              connection: {
                status: 'ok',
                delta: 0,
                sameViaPoint: true,
                deltaTime: 10_800
              },
              duration: 49_200,
              lostServices: [
                {
                  descriptions: [
                    {
                      type: 'shortText',
                      content: 'SURF'
                    }
                  ],
                  isChargeable: true,
                  originalFlightId: 'ST2',
                  targetFlightIds: [
                    'ST4'
                  ],
                  travelerIds: [
                    'PT1'
                  ]
                }
              ],
              lostSeats: [
                {
                  seatSelections: [
                    {
                      seatNumber: '3A',
                      travelerId: 'PT1'
                    }
                  ],
                  isChargeable: true,
                  originalFlightId: 'ST2',
                  targetFlightIds: [
                    'ST4'
                  ]
                }
              ],
              degradedSeats: [
                {
                  seatId: 'OT15'
                }
              ]
            },
            originLocation: COTE_D_AZUR,
            destinationLocation: JOHN_F_KENNEDY_INTL,
            id: 'ST1:ST4',
            quota: 1.797_693_134_862_315_7e+308
          },
          {
            airBoundId: '2',
            originLocationCode: 'JFK',
            destinationLocationCode: 'NCE',
            flights: [
              {
                id: 'ST3',
                cabin: 'business',
                bookingClass: 'J',
                operating: {
                  bookingClass: 'J'
                },
                statusCode: 'HK',
                arrivalDaysDifference: 1,
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'DL',
                  marketingFlightNumber: '3593',
                  operatingAirlineFlightNumber: '028',
                  departure: {
                    locationCode: 'JFK',
                    dateTime: new utils.DateTime(todayPlusNdays('19:40', 25)),
                    terminal: '4',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('23:40', 25)),
                    location: JOHN_F_KENNEDY_INTL
                  },
                  arrival: {
                    locationCode: 'NCE',
                    dateTime: new utils.DateTime(todayPlusNdays('10:00', 26)),
                    terminal: '2',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('08:00', 26)),
                    location: COTE_D_AZUR
                  },
                  aircraftCode: '764',
                  duration: 30_000,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: true,
                  meals: {
                    bookingClass: 'J',
                    mealCodes: [
                      'D'
                    ]
                  },
                  flightStatus: 'scheduled'
                },
                bookingStatus: {
                  name: 'Holding confirmed'
                }
              }
            ],
            duration: 30_000,
            originLocation: {
              ...JOHN_F_KENNEDY_INTL
            },
            destinationLocation: COTE_D_AZUR,
            id: 'ST3',
            quota: 1.797_693_134_862_315_7e+308
          }
        ]
      },
      services: [
        {
          id: 'OT9',
          descriptions: [
            {
              type: 'shortText',
              content: 'SURF'
            }
          ],
          reasonForIssuance: {
            code: 'C',
            subCode: '0GD'
          },
          quantity: 1,
          flightIds: [
            'ST1'
          ],
          statusCode: 'HK',
          travelerId: 'PT1',
          isChargeable: true,
          prices: {
            unitPrices: [
              {
                prices: [
                  {
                    base: createAmount({
                      template: {
                        value: 2500
                      }
                    }),
                    total: createAmount({
                      template: {
                        value: 2500
                      }
                    })
                  }
                ]
              }
            ],
            totalPrices: [
              {
                base: createAmount({
                  template: {
                    value: 2500
                  }
                }),
                total: createAmount({
                  template: {
                    value: 2500
                  }
                })
              }
            ]
          },
          status: {
            name: 'Holding confirmed'
          }
        },
        {
          id: 'OT10',
          descriptions: [
            {
              type: 'shortText',
              content: 'SURF'
            }
          ],
          reasonForIssuance: {
            code: 'C',
            subCode: '0GD'
          },
          quantity: 1,
          flightIds: [
            'ST2'
          ],
          statusCode: 'UN',
          travelerId: 'PT1',
          isChargeable: true,
          status: {
            name: 'Unable, does not operate'
          }
        },
        {
          id: 'OT11',
          descriptions: [
            {
              type: 'shortText',
              content: 'ABAG'
            }
          ],
          reasonForIssuance: {
            code: 'C',
            subCode: '0CC'
          },
          quantity: 1,
          flightIds: [
            'ST1'
          ],
          statusCode: 'HK',
          travelerId: 'PT1',
          isChargeable: true,
          prices: {
            unitPrices: [
              {
                prices: [
                  {
                    base: createAmount({
                      template: {
                        value: 19_200
                      }
                    }),
                    total: createAmount({
                      template: {
                        value: 19_200
                      }
                    })
                  }
                ]
              }
            ],
            totalPrices: [
              {
                base: createAmount({
                  template: {
                    value: 19_200
                  }
                }),
                total: createAmount({
                  template: {
                    value: 19_200
                  }
                })
              }
            ]
          },
          status: {
            name: 'Holding confirmed'
          }
        },
        {
          id: 'OT12',
          descriptions: [
            {
              type: 'shortText',
              content: 'ABAG'
            }
          ],
          reasonForIssuance: {
            code: 'C',
            subCode: '0CC'
          },
          quantity: 1,
          flightIds: [
            'ST2'
          ],
          statusCode: 'UN',
          travelerId: 'PT1',
          isChargeable: true,
          status: {
            name: 'Unable, does not operate'
          }
        },
        {
          id: 'OT13',
          descriptions: [
            {
              type: 'shortText',
              content: 'COLA'
            }
          ],
          reasonForIssuance: {
            code: 'G',
            subCode: '032'
          },
          quantity: 1,
          flightIds: [
            'ST1'
          ],
          statusCode: 'HK',
          travelerId: 'PT1',
          isChargeable: true,
          prices: {
            unitPrices: [
              {
                prices: [
                  {
                    base: createAmount({
                      template: {
                        value: 6000
                      }
                    }),
                    total: createAmount({
                      template: {
                        value: 6000
                      }
                    })
                  }
                ]
              }
            ],
            totalPrices: [
              {
                base: createAmount({
                  template: {
                    value: 6000
                  }
                }),
                total: createAmount({
                  template: {
                    value: 6000
                  }
                })
              }
            ]
          },
          status: {
            name: 'Holding confirmed'
          }
        },
        {
          id: 'OT14',
          descriptions: [
            {
              type: 'shortText',
              content: 'COLA'
            }
          ],
          reasonForIssuance: {
            code: 'G',
            subCode: '032'
          },
          quantity: 1,
          flightIds: [
            'ST2'
          ],
          statusCode: 'UN',
          travelerId: 'PT1',
          isChargeable: true,
          status: {
            name: 'Unable, does not operate'
          }
        },
        {
          id: 'OT73',
          descriptions: [
            {
              type: 'shortText',
              content: 'SURF'
            }
          ],
          reasonForIssuance: {
            code: 'C',
            subCode: '0GD'
          },
          quantity: 1,
          flightIds: [
            'ST4'
          ],
          statusCode: 'HK',
          travelerId: 'PT1',
          isChargeable: true,
          status: {
            name: 'Holding confirmed'
          }
        },
        {
          id: 'OT74',
          descriptions: [
            {
              type: 'shortText',
              content: 'ABAG'
            }
          ],
          reasonForIssuance: {
            code: 'C',
            subCode: '0CC'
          },
          quantity: 1,
          flightIds: [
            'ST4'
          ],
          statusCode: 'HK',
          travelerId: 'PT1',
          isChargeable: true,
          status: {
            name: 'Holding confirmed'
          }
        },
        {
          id: 'OT75',
          descriptions: [
            {
              type: 'shortText',
              content: 'COLA'
            }
          ],
          reasonForIssuance: {
            code: 'G',
            subCode: '032'
          },
          quantity: 1,
          flightIds: [
            'ST4'
          ],
          statusCode: 'HK',
          travelerId: 'PT1',
          isChargeable: true,
          status: {
            name: 'Holding confirmed'
          }
        }
      ],
      seats: [
        {
          id: 'OT18',
          flightId: 'ST2',
          seatSelections: [
            {
              seatNumber: '3A',
              travelerId: 'PT1',
              seatCharacteristics: [
                {
                  code: 'N'
                },
                {
                  code: 'W'
                },
                {
                  code: 'A'
                },
                {
                  code: 'K'
                }
              ],
              isChargeable: false
            }
          ],
          statusCode: 'UN',
          status: {
            name: 'Unable, does not operate'
          }
        },
        {
          id: 'OT15',
          flightId: 'ST1',
          seatSelections: [
            {
              seatNumber: '1A',
              travelerId: 'PT1',
              seatCharacteristics: [
                {
                  code: 'N'
                },
                {
                  code: 'W'
                },
                {
                  code: 'K'
                }
              ],
              isChargeable: false
            }
          ],
          statusCode: 'HK',
          status: {
            name: 'Holding confirmed'
          }
        },
        {
          id: 'OT70',
          flightId: 'ST4',
          seatSelections: [
            {
              seatNumber: '3A',
              travelerId: 'PT1',
              seatCharacteristics: [
                {
                  code: 'N'
                },
                {
                  code: 'W'
                },
                {
                  code: 'A'
                },
                {
                  code: 'K'
                }
              ],
              isChargeable: false
            }
          ],
          statusCode: 'KK',
          status: {
            name: 'Confirmed'
          }
        },
        {
          id: 'OT21',
          flightId: 'ST3',
          seatSelections: [
            {
              seatNumber: '1A',
              travelerId: 'PT1',
              seatCharacteristics: [
                {
                  code: 'N'
                }
              ],
              isChargeable: false
            }
          ],
          statusCode: 'HK',
          status: {
            name: 'Holding confirmed'
          }
        }
      ],
      travelers: [
        createTraveler({
          template: {
            passengerTypeCode: 'ADT',
            id: 'PT1',
            names: [createName()]
          }
        })
      ],
      paymentRecords: [createPaymentRecord({
        template: {
          id: 'FPT41',
          travelerIds: [
            'PT1'
          ],
          flightIds: [
            'ST1',
            'ST3'
          ],
          paymentTransactions: [
            {
              paymentMethod: createPaymentCard({
                template: {
                  cardNumber: 'xxxxxxxxxxxx9999'
                }
              }),
              amount: createAmount({
                template: {
                  value: 929_518
                }
              })
            }
          ]
        }
      })],
      contacts: [
        ...contacts
      ],
      orderEligibilities: createOrderEligibilities({
        template: {
          acknowledge: {
            ...acknowledgeMock
          },
          cancel: {
            ...cancelMock
          },
          cancelAndRefund: {
            ...cancelAndRefundMock
          },
          change: [...changeMock],
          flightReaccommodation: {
            ...flightReaccommodationMock
          }
        }
      })
    }
  })
});

export const retrieveOrderMockDisruptedMultiBoundsWithLostServices = createOrder({
  template: {
    id: 'SI9SIO',
    creationPointOfSale: {
      pointOfSaleId: 'PARAF08AA',
      countryCode: 'FR',
      country: 'FRANCE'
    },
    isGroupBooking: false,
    air: {
      bounds: [
        {
          airBoundId: '1',
          originLocationCode: 'NCE',
          destinationLocationCode: 'JFK',
          flights: [
            {
              id: 'ST1',
              cabin: 'business',
              bookingClass: 'J',
              statusCode: 'HK',
              connectionTime: 24_000,
              flight: {
                marketingAirlineCode: 'AF',
                marketingAirline: 'AF',
                operatingAirlineCode: 'AF',
                marketingFlightNumber: '7711',
                operatingAirlineFlightNumber: '7711',
                departure: {
                  locationCode: 'NCE',
                  dateTime: new utils.DateTime(todayPlusNdays('06:10', 15)),
                  terminal: '2',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('04:10', 15)),
                  location: COTE_D_AZUR
                },
                arrival: {
                  locationCode: 'CDG',
                  dateTime: new utils.DateTime(todayPlusNdays('07:40', 15)),
                  terminal: '2F',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('05:40', 15)),
                  location: CHARLES_DE_GAULLE
                },
                aircraftCode: '319',
                duration: 5400,
                isOpenSegment: false,
                isInformational: false,
                secureFlightIndicator: false,
                flightStatus: 'scheduled'
              },
              bookingStatus: {
                name: 'Holding confirmed'
              }
            },
            {
              id: 'ST4',
              cabin: 'business',
              bookingClass: 'J',
              statusCode: 'TK',
              flight: {
                marketingAirlineCode: 'AF',
                marketingAirline: 'AF',
                operatingAirlineCode: 'AF',
                marketingFlightNumber: '006',
                operatingAirlineFlightNumber: '006',
                departure: {
                  locationCode: 'CDG',
                  terminal: '1',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('12:20', 15)),
                  location: CHARLES_DE_GAULLE
                },
                arrival: {
                  locationCode: 'JFK',
                  dateTime: new utils.DateTime(todayPlusNdays('17:00', 15)),
                  terminal: '1',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('21:00', 15)),
                  location: JOHN_F_KENNEDY_INTL
                },
                aircraftCode: '77W',
                duration: 31_200,
                isOpenSegment: false,
                isInformational: false,
                secureFlightIndicator: true,
                flightStatus: 'scheduled'
              },
              bookingStatus: {
                name: 'Confirmed, timechange'
              }
            }
          ],
          duration: 60_600,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST1',
                cabin: 'business',
                bookingClass: 'J',
                statusCode: 'HK',
                connectionTime: 13_200,
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'AF',
                  marketingFlightNumber: '7711',
                  operatingAirlineFlightNumber: '7711',
                  departure: {
                    locationCode: 'NCE',
                    dateTime: new utils.DateTime(todayPlusNdays('06:10', 15)),
                    terminal: '2',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('04:10', 15)),
                    location: COTE_D_AZUR
                  },
                  arrival: {
                    locationCode: 'CDG',
                    dateTime: new utils.DateTime(todayPlusNdays('07:40', 15)),
                    terminal: '2F',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('05:40', 15)),
                    location: CHARLES_DE_GAULLE
                  },
                  aircraftCode: '319',
                  duration: 5400,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: false,
                  flightStatus: 'scheduled'
                },
                bookingStatus: {
                  name: 'Holding confirmed'
                }
              },
              {
                id: 'ST2',
                cabin: 'business',
                bookingClass: 'J',
                statusCode: 'UN',
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'AF',
                  marketingFlightNumber: '014',
                  operatingAirlineFlightNumber: '014',
                  departure: {
                    locationCode: 'CDG',
                    dateTime: new utils.DateTime(todayPlusNdays('11:20', 15)),
                    terminal: '2E',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('09:20', 15)),
                    location: CHARLES_DE_GAULLE
                  },
                  arrival: {
                    locationCode: 'JFK',
                    dateTime: new utils.DateTime(todayPlusNdays('13:50', 15)),
                    terminal: '1',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('17:50', 15)),
                    location: JOHN_F_KENNEDY_INTL
                  },
                  aircraftCode: '77W',
                  duration: 30_600,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: true,
                  meals: {
                    bookingClass: 'J',
                    mealCodes: [
                      'M',
                      'S'
                    ]
                  },
                  flightStatus: 'cancelled'
                },
                bookingStatus: {
                  name: 'Unable, does not operate'
                }
              }
            ],
            departure: {
              locationCode: 'NCE',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 0,
              destinationLocation: COTE_D_AZUR
            },
            arrival: {
              locationCode: 'JFK',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 11_400,
              destinationLocation: JOHN_F_KENNEDY_INTL
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 10_800
            },
            duration: 49_200,
            lostServices: [
              {
                descriptions: [
                  {
                    type: 'shortText',
                    content: 'SURF'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST2',
                targetFlightIds: [
                  'ST4'
                ],
                travelerIds: [
                  'PT1'
                ]
              }
            ],
            lostSeats: [
              {
                seatSelections: [
                  {
                    seatNumber: '3A',
                    travelerId: 'PT1'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST2',
                targetFlightIds: [
                  'ST4'
                ]
              }
            ],
            degradedSeats: [
              {
                seatId: 'OT15'
              }
            ]
          },
          originLocation: COTE_D_AZUR,
          destinationLocation: JOHN_F_KENNEDY_INTL,
          id: 'ST1:ST4',
          quota: 1.797_693_134_862_315_7e+308
        },
        {
          airBoundId: '2',
          originLocationCode: 'JFK',
          destinationLocationCode: 'NCE',
          flights: [
            {
              id: 'ST5',
              cabin: 'business',
              bookingClass: 'J',
              operating: {
                bookingClass: 'J'
              },
              statusCode: 'TK',
              arrivalDaysDifference: 1,
              flight: {
                marketingAirlineCode: 'AF',
                marketingAirline: 'AF',
                operatingAirlineCode: 'DL',
                marketingFlightNumber: '3593',
                operatingAirlineFlightNumber: '028',
                departure: {
                  locationCode: 'JFK',
                  dateTime: new utils.DateTime(todayPlusNdays('19:40', 25)),
                  terminal: '4',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('23:40', 25)),
                  location: JOHN_F_KENNEDY_INTL
                },
                arrival: {
                  locationCode: 'NCE',
                  dateTime: new utils.DateTime(todayPlusNdays('10:00', 26)),
                  terminal: '2',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('08:00', 26)),
                  location: COTE_D_AZUR
                },
                aircraftCode: '764',
                duration: 30_000,
                isOpenSegment: false,
                isInformational: false,
                secureFlightIndicator: true,
                meals: {
                  bookingClass: 'J',
                  mealCodes: [
                    'D'
                  ]
                },
                flightStatus: 'scheduled'
              },
              bookingStatus: {
                name: 'Confirmed, timechange'
              }
            }
          ],
          duration: 30_000,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST3',
                cabin: 'business',
                bookingClass: 'J',
                operating: {
                  bookingClass: 'J'
                },
                statusCode: 'UN',
                arrivalDaysDifference: 1,
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'DL',
                  marketingFlightNumber: '3588',
                  operatingAirlineFlightNumber: '047',
                  departure: {
                    locationCode: 'JFK',
                    dateTime: new utils.DateTime(todayPlusNdays('18:00', 25)),
                    terminal: '4',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('22:00', 25)),
                    location: JOHN_F_KENNEDY_INTL
                  },
                  arrival: {
                    locationCode: 'NCE',
                    dateTime: new utils.DateTime(todayPlusNdays('10:00', 26)),
                    terminal: '2',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('06:20', 26)),
                    location: COTE_D_AZUR
                  },
                  aircraftCode: '764',
                  duration: 30_000,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: true,
                  meals: {
                    bookingClass: 'J',
                    mealCodes: [
                      'D'
                    ]
                  },
                  flightStatus: 'cancelled'
                },
                bookingStatus: {
                  name: 'cancelled'
                }
              }
            ],
            departure: {
              locationCode: 'JFK',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 11_400,
              destinationLocation: JOHN_F_KENNEDY_INTL
            },
            arrival: {
              locationCode: 'NCE',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 0,
              destinationLocation: COTE_D_AZUR
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 10_800
            },
            duration: 30_000,
            lostServices: [
              {
                descriptions: [
                  {
                    type: 'shortText',
                    content: 'SURF'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST3',
                targetFlightIds: [
                  'ST5'
                ],
                travelerIds: [
                  'PT1'
                ]
              }
            ],
            lostSeats: [
              {
                seatSelections: [
                  {
                    seatNumber: '1A',
                    travelerId: 'PT1'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST3',
                targetFlightIds: [
                  'ST5'
                ]
              }
            ],
            degradedSeats: [
              {
                seatId: 'OT70'
              }
            ]
          },
          originLocation: {
            ...JOHN_F_KENNEDY_INTL
          },
          destinationLocation: COTE_D_AZUR,
          id: 'ST5',
          quota: 1.797_693_134_862_315_7e+308
        }
      ]
    },
    services: [
      {
        id: 'OT9',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: createAmount({
                    template: {
                      value: 2500
                    }
                  }),
                  total: createAmount({
                    template: {
                      value: 2500
                    }
                  })
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: createAmount({
                template: {
                  value: 2500
                }
              }),
              total: createAmount({
                template: {
                  value: 2500
                }
              })
            }
          ]
        },
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT10',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT11',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0CC'
        },
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: createAmount({
                    template: {
                      value: 19_200
                    }
                  }),
                  total: createAmount({
                    template: {
                      value: 19_200
                    }
                  })
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: createAmount({
                template: {
                  value: 19_200
                }
              }),
              total: createAmount({
                template: {
                  value: 19_200
                }
              })
            }
          ]
        },
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT12',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0CC'
        },
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT13',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        reasonForIssuance: {
          code: 'G',
          subCode: '032'
        },
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: createAmount({
                    template: {
                      value: 6000
                    }
                  }),
                  total: createAmount({
                    template: {
                      value: 6000
                    }
                  })
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: createAmount({
                template: {
                  value: 6000
                }
              }),
              total: createAmount({
                template: {
                  value: 6000
                }
              })
            }
          ]
        },
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT14',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        reasonForIssuance: {
          code: 'G',
          subCode: '032'
        },
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT73',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST4'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT74',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0CC'
        },
        quantity: 1,
        flightIds: [
          'ST4'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT75',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        reasonForIssuance: {
          code: 'G',
          subCode: '032'
        },
        quantity: 1,
        flightIds: [
          'ST4'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT76',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST3'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT77',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST5'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      }
    ],
    seats: [
      {
        id: 'OT18',
        flightId: 'ST2',
        seatSelections: [
          {
            seatNumber: '3A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              },
              {
                code: 'W'
              },
              {
                code: 'A'
              },
              {
                code: 'K'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'UN',
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT15',
        flightId: 'ST1',
        seatSelections: [
          {
            seatNumber: '1A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              },
              {
                code: 'W'
              },
              {
                code: 'K'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'HK',
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT70',
        flightId: 'ST4',
        seatSelections: [
          {
            seatNumber: '3A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              },
              {
                code: 'W'
              },
              {
                code: 'A'
              },
              {
                code: 'K'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'KK',
        status: {
          name: 'Confirmed'
        }
      },
      {
        id: 'OT21',
        flightId: 'ST3',
        seatSelections: [
          {
            seatNumber: '1A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'UN',
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT81',
        flightId: 'ST5',
        seatSelections: [
          {
            seatNumber: '1A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'HK',
        status: {
          name: 'Holding confirmed'
        }
      }
    ],
    travelers: [
      createTraveler({
        template: {
          passengerTypeCode: 'ADT',
          id: 'PT1',
          names: [createName()]
        }
      })
    ],
    paymentRecords: [createPaymentRecord({
      template: {
        id: 'FPT41',
        travelerIds: [
          'PT1'
        ],
        flightIds: [
          'ST1'
        ],
        paymentTransactions: [
          {
            paymentMethod: createPaymentCard({
              template: {
                cardNumber: 'xxxxxxxxxxxx9999'
              }
            }),
            amount: createAmount({
              template: {
                value: 929_518
              }
            })
          }
        ]
      }
    })],
    contacts: [
      ...contacts
    ],
    orderEligibilities: createOrderEligibilities({
      template: {
        acknowledge: {
          ...acknowledgeMock
        },
        cancel: {
          ...cancelMock
        },
        cancelAndRefund: {
          ...cancelAndRefundMock
        },
        change: [...changeMock],
        flightReaccommodation: {
          acknowledge: [
            {
              airBoundId: '1',
              isEligible: true
            },
            {
              airBoundId: '2',
              isEligible: true
            }
          ],
          change: [
            {
              airBoundId: '1',
              isEligible: true
            },
            {
              airBoundId: '2',
              isEligible: true
            }
          ]
        }
      }
    })
  }
});

export const retrieveOrderMockDisruptedInBoundsWithLostServices = createOrder({
  template: {
    id: 'SI9SIO',
    creationPointOfSale: {
      pointOfSaleId: 'PARAF08AA',
      countryCode: 'FR',
      country: 'FRANCE'
    },
    isGroupBooking: false,
    air: {
      bounds: [
        {
          airBoundId: '1',
          originLocationCode: 'NCE',
          destinationLocationCode: 'JFK',
          flights: [
            {
              id: 'ST1',
              cabin: 'business',
              bookingClass: 'J',
              statusCode: 'HK',
              connectionTime: 24_000,
              flight: {
                marketingAirlineCode: 'AF',
                marketingAirline: 'AF',
                operatingAirlineCode: 'AF',
                marketingFlightNumber: '7711',
                operatingAirlineFlightNumber: '7711',
                departure: {
                  locationCode: 'NCE',
                  dateTime: new utils.DateTime(todayPlusNdays('06:10', 15)),
                  terminal: '2',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('04:10', 15)),
                  location: COTE_D_AZUR
                },
                arrival: {
                  locationCode: 'CDG',
                  dateTime: new utils.DateTime(todayPlusNdays('07:40', 15)),
                  terminal: '2F',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('05:40', 15)),
                  location: CHARLES_DE_GAULLE
                },
                aircraftCode: '319',
                duration: 5400,
                isOpenSegment: false,
                isInformational: false,
                secureFlightIndicator: false,
                flightStatus: 'scheduled'
              },
              bookingStatus: {
                name: 'Holding confirmed'
              }
            },
            {
              id: 'ST4',
              cabin: 'business',
              bookingClass: 'J',
              statusCode: 'HK',
              flight: {
                marketingAirlineCode: 'AF',
                marketingAirline: 'AF',
                operatingAirlineCode: 'AF',
                marketingFlightNumber: '006',
                operatingAirlineFlightNumber: '006',
                departure: {
                  locationCode: 'CDG',
                  terminal: '1',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('12:20', 15)),
                  location: CHARLES_DE_GAULLE
                },
                arrival: {
                  locationCode: 'JFK',
                  dateTime: new utils.DateTime(todayPlusNdays('17:00', 15)),
                  terminal: '1',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('21:00', 15)),
                  location: JOHN_F_KENNEDY_INTL
                },
                aircraftCode: '77W',
                duration: 31_200,
                isOpenSegment: false,
                isInformational: false,
                secureFlightIndicator: true,
                flightStatus: 'scheduled'
              },
              bookingStatus: {
                name: 'Holding confirmed'
              }
            }
          ],
          duration: 60_600,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST1',
                cabin: 'business',
                bookingClass: 'J',
                statusCode: 'HK',
                connectionTime: 13_200,
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'AF',
                  marketingFlightNumber: '7711',
                  operatingAirlineFlightNumber: '7711',
                  departure: {
                    locationCode: 'NCE',
                    dateTime: new utils.DateTime(todayPlusNdays('06:10', 15)),
                    terminal: '2',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('04:10', 15)),
                    location: COTE_D_AZUR
                  },
                  arrival: {
                    locationCode: 'CDG',
                    dateTime: new utils.DateTime(todayPlusNdays('07:40', 15)),
                    terminal: '2F',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('05:40', 15)),
                    location: CHARLES_DE_GAULLE
                  },
                  aircraftCode: '319',
                  duration: 5400,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: false,
                  flightStatus: 'scheduled'
                },
                bookingStatus: {
                  name: 'Holding confirmed'
                }
              },
              {
                id: 'ST2',
                cabin: 'business',
                bookingClass: 'J',
                statusCode: 'UN',
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'AF',
                  marketingFlightNumber: '014',
                  operatingAirlineFlightNumber: '014',
                  departure: {
                    locationCode: 'CDG',
                    dateTime: new utils.DateTime(todayPlusNdays('11:20', 15)),
                    terminal: '2E',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('09:20', 15)),
                    location: CHARLES_DE_GAULLE
                  },
                  arrival: {
                    locationCode: 'JFK',
                    dateTime: new utils.DateTime(todayPlusNdays('13:50', 15)),
                    terminal: '1',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('17:50', 15)),
                    location: JOHN_F_KENNEDY_INTL
                  },
                  aircraftCode: '77W',
                  duration: 30_600,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: true,
                  meals: {
                    bookingClass: 'J',
                    mealCodes: [
                      'M',
                      'S'
                    ]
                  },
                  flightStatus: 'cancelled'
                },
                bookingStatus: {
                  name: 'Unable, does not operate'
                }
              }
            ],
            departure: {
              locationCode: 'NCE',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 0,
              destinationLocation: COTE_D_AZUR
            },
            arrival: {
              locationCode: 'JFK',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 11_400,
              destinationLocation: JOHN_F_KENNEDY_INTL
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 10_800
            },
            duration: 49_200,
            lostServices: [
              {
                descriptions: [
                  {
                    type: 'shortText',
                    content: 'SURF'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST2',
                targetFlightIds: [
                  'ST4'
                ],
                travelerIds: [
                  'PT1'
                ]
              }
            ],
            lostSeats: [
              {
                seatSelections: [
                  {
                    seatNumber: '3A',
                    travelerId: 'PT1'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST2',
                targetFlightIds: [
                  'ST4'
                ]
              }
            ],
            degradedSeats: [
              {
                seatId: 'OT15'
              }
            ]
          },
          originLocation: COTE_D_AZUR,
          destinationLocation: JOHN_F_KENNEDY_INTL,
          id: 'ST1:ST4',
          quota: 1.797_693_134_862_315_7e+308
        },
        {
          airBoundId: '2',
          originLocationCode: 'JFK',
          destinationLocationCode: 'NCE',
          flights: [
            {
              id: 'ST5',
              cabin: 'business',
              bookingClass: 'J',
              operating: {
                bookingClass: 'J'
              },
              statusCode: 'TK',
              arrivalDaysDifference: 1,
              flight: {
                marketingAirlineCode: 'AF',
                marketingAirline: 'AF',
                operatingAirlineCode: 'DL',
                marketingFlightNumber: '3593',
                operatingAirlineFlightNumber: '028',
                departure: {
                  locationCode: 'JFK',
                  dateTime: new utils.DateTime(todayPlusNdays('19:40', 25)),
                  terminal: '4',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('23:40', 25)),
                  location: JOHN_F_KENNEDY_INTL
                },
                arrival: {
                  locationCode: 'NCE',
                  dateTime: new utils.DateTime(todayPlusNdays('10:00', 26)),
                  terminal: '2',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('08:00', 26)),
                  location: COTE_D_AZUR
                },
                aircraftCode: '764',
                duration: 30_000,
                isOpenSegment: false,
                isInformational: false,
                secureFlightIndicator: true,
                meals: {
                  bookingClass: 'J',
                  mealCodes: [
                    'D'
                  ]
                },
                flightStatus: 'scheduled'
              },
              bookingStatus: {
                name: 'Confirmed, timechange'
              }
            }
          ],
          duration: 30_000,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST3',
                cabin: 'business',
                bookingClass: 'J',
                operating: {
                  bookingClass: 'J'
                },
                statusCode: 'UN',
                arrivalDaysDifference: 1,
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'DL',
                  marketingFlightNumber: '3588',
                  operatingAirlineFlightNumber: '047',
                  departure: {
                    locationCode: 'JFK',
                    dateTime: new utils.DateTime(todayPlusNdays('18:00', 25)),
                    terminal: '4',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('22:00', 25)),
                    location: JOHN_F_KENNEDY_INTL
                  },
                  arrival: {
                    locationCode: 'NCE',
                    dateTime: new utils.DateTime(todayPlusNdays('10:00', 26)),
                    terminal: '2',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('06:20', 26)),
                    location: COTE_D_AZUR
                  },
                  aircraftCode: '764',
                  duration: 30_000,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: true,
                  meals: {
                    bookingClass: 'J',
                    mealCodes: [
                      'D'
                    ]
                  },
                  flightStatus: 'cancelled'
                },
                bookingStatus: {
                  name: 'cancelled'
                }
              }
            ],
            departure: {
              locationCode: 'JFK',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 11_400,
              destinationLocation: JOHN_F_KENNEDY_INTL
            },
            arrival: {
              locationCode: 'NCE',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 0,
              destinationLocation: COTE_D_AZUR
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 10_800
            },
            duration: 30_000,
            lostServices: [
              {
                descriptions: [
                  {
                    type: 'shortText',
                    content: 'SURF'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST3',
                targetFlightIds: [
                  'ST5'
                ],
                travelerIds: [
                  'PT1'
                ]
              }
            ],
            lostSeats: [
              {
                seatSelections: [
                  {
                    seatNumber: '1A',
                    travelerId: 'PT1'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST3',
                targetFlightIds: [
                  'ST5'
                ]
              }
            ],
            degradedSeats: [
              {
                seatId: 'OT70'
              }
            ]
          },
          originLocation: {
            ...JOHN_F_KENNEDY_INTL
          },
          destinationLocation: COTE_D_AZUR,
          id: 'ST5',
          quota: 1.797_693_134_862_315_7e+308
        }
      ]
    },
    services: [
      {
        id: 'OT9',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: createAmount({
                    template: {
                      value: 2500
                    }
                  }),
                  total: createAmount({
                    template: {
                      value: 2500
                    }
                  })
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: createAmount({
                template: {
                  value: 2500
                }
              }),
              total: createAmount({
                template: {
                  value: 2500
                }
              })
            }
          ]
        },
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT10',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT11',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0CC'
        },
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: createAmount({
                    template: {
                      value: 19_200
                    }
                  }),
                  total: createAmount({
                    template: {
                      value: 19_200
                    }
                  })
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: createAmount({
                template: {
                  value: 19_200
                }
              }),
              total: createAmount({
                template: {
                  value: 19_200
                }
              })
            }
          ]
        },
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT12',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0CC'
        },
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT13',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        reasonForIssuance: {
          code: 'G',
          subCode: '032'
        },
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: createAmount({
                    template: {
                      value: 6000
                    }
                  }),
                  total: createAmount({
                    template: {
                      value: 6000
                    }
                  })
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: createAmount({
                template: {
                  value: 6000
                }
              }),
              total: createAmount({
                template: {
                  value: 6000
                }
              })
            }
          ]
        },
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT14',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        reasonForIssuance: {
          code: 'G',
          subCode: '032'
        },
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT73',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST4'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT74',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0CC'
        },
        quantity: 1,
        flightIds: [
          'ST4'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT75',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        reasonForIssuance: {
          code: 'G',
          subCode: '032'
        },
        quantity: 1,
        flightIds: [
          'ST4'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT76',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST3'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT77',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST5'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      }
    ],
    seats: [
      {
        id: 'OT18',
        flightId: 'ST2',
        seatSelections: [
          {
            seatNumber: '3A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              },
              {
                code: 'W'
              },
              {
                code: 'A'
              },
              {
                code: 'K'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'UN',
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT15',
        flightId: 'ST1',
        seatSelections: [
          {
            seatNumber: '1A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              },
              {
                code: 'W'
              },
              {
                code: 'K'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'HK',
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT70',
        flightId: 'ST4',
        seatSelections: [
          {
            seatNumber: '3A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              },
              {
                code: 'W'
              },
              {
                code: 'A'
              },
              {
                code: 'K'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'KK',
        status: {
          name: 'Confirmed'
        }
      },
      {
        id: 'OT21',
        flightId: 'ST3',
        seatSelections: [
          {
            seatNumber: '1A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'UN',
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT81',
        flightId: 'ST5',
        seatSelections: [
          {
            seatNumber: '1A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'HK',
        status: {
          name: 'Holding confirmed'
        }
      }
    ],
    travelers: [
      createTraveler({
        template: {
          passengerTypeCode: 'ADT',
          id: 'PT1',
          names: [createName()]
        }
      })
    ],
    paymentRecords: [createPaymentRecord({
      template: {
        id: 'FPT41',
        travelerIds: [
          'PT1'
        ],
        flightIds: [
          'ST1'
        ],
        paymentTransactions: [
          {
            paymentMethod: createPaymentCard({
              template: {
                cardNumber: 'xxxxxxxxxxxx9999'
              }
            }),
            amount: createAmount({
              template: {
                value: 929_518
              }
            })
          }
        ]
      }
    })],
    contacts: [
      ...contacts
    ],
    orderEligibilities: createOrderEligibilities({
      template: {
        acknowledge: {
          ...acknowledgeMock
        },
        cancel: {
          ...cancelMock
        },
        cancelAndRefund: {
          ...cancelAndRefundMock
        },
        change: [...changeMock],
        flightReaccommodation: {
          acknowledge: [
            {
              airBoundId: '2',
              isEligible: true
            }
          ],
          change: [
            {
              airBoundId: '2',
              isEligible: true
            }
          ]
        }
      }
    })
  }
});

export const retrieveOrderMockReaccomodatedMultiBoundsWithLostServices = createOrder({
  template: {
    id: 'SI9SIO',
    creationPointOfSale: {
      pointOfSaleId: 'PARAF08AA',
      countryCode: 'FR',
      country: 'FRANCE'
    },
    isGroupBooking: false,
    air: {
      bounds: [
        {
          airBoundId: '1',
          originLocationCode: 'NCE',
          destinationLocationCode: 'JFK',
          flights: [
            {
              id: 'ST1',
              cabin: 'business',
              bookingClass: 'J',
              statusCode: 'HK',
              connectionTime: 24_000,
              flight: {
                marketingAirlineCode: 'AF',
                marketingAirline: 'AF',
                operatingAirlineCode: 'AF',
                marketingFlightNumber: '7711',
                operatingAirlineFlightNumber: '7711',
                departure: {
                  locationCode: 'NCE',
                  dateTime: new utils.DateTime(todayPlusNdays('06:10', 15)),
                  terminal: '2',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('04:10', 15)),
                  location: COTE_D_AZUR
                },
                arrival: {
                  locationCode: 'CDG',
                  dateTime: new utils.DateTime(todayPlusNdays('07:40', 15)),
                  terminal: '2F',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('05:40', 15)),
                  location: CHARLES_DE_GAULLE
                },
                aircraftCode: '319',
                duration: 5400,
                isOpenSegment: false,
                isInformational: false,
                secureFlightIndicator: false,
                flightStatus: 'scheduled'
              },
              bookingStatus: {
                name: 'Holding confirmed'
              }
            },
            {
              id: 'ST4',
              cabin: 'business',
              bookingClass: 'J',
              statusCode: 'HK',
              flight: {
                marketingAirlineCode: 'AF',
                marketingAirline: 'AF',
                operatingAirlineCode: 'AF',
                marketingFlightNumber: '006',
                operatingAirlineFlightNumber: '006',
                departure: {
                  locationCode: 'CDG',
                  terminal: '1',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('12:20', 15)),
                  location: CHARLES_DE_GAULLE
                },
                arrival: {
                  locationCode: 'JFK',
                  dateTime: new utils.DateTime(todayPlusNdays('17:00', 15)),
                  terminal: '1',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('21:00', 15)),
                  location: JOHN_F_KENNEDY_INTL
                },
                aircraftCode: '77W',
                duration: 31_200,
                isOpenSegment: false,
                isInformational: false,
                secureFlightIndicator: true,
                flightStatus: 'scheduled'
              },
              bookingStatus: {
                name: 'Holding confirmed'
              }
            }
          ],
          duration: 60_600,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST1',
                cabin: 'business',
                bookingClass: 'J',
                statusCode: 'HK',
                connectionTime: 13_200,
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'AF',
                  marketingFlightNumber: '7711',
                  operatingAirlineFlightNumber: '7711',
                  departure: {
                    locationCode: 'NCE',
                    dateTime: new utils.DateTime(todayPlusNdays('06:10', 15)),
                    terminal: '2',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('04:10', 15)),
                    location: COTE_D_AZUR
                  },
                  arrival: {
                    locationCode: 'CDG',
                    dateTime: new utils.DateTime(todayPlusNdays('07:40', 15)),
                    terminal: '2F',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('05:40', 15)),
                    location: CHARLES_DE_GAULLE
                  },
                  aircraftCode: '319',
                  duration: 5400,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: false,
                  flightStatus: 'scheduled'
                },
                bookingStatus: {
                  name: 'Holding confirmed'
                }
              },
              {
                id: 'ST2',
                cabin: 'business',
                bookingClass: 'J',
                statusCode: 'UN',
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'AF',
                  marketingFlightNumber: '014',
                  operatingAirlineFlightNumber: '014',
                  departure: {
                    locationCode: 'CDG',
                    dateTime: new utils.DateTime(todayPlusNdays('11:20', 15)),
                    terminal: '2E',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('09:20', 15)),
                    location: CHARLES_DE_GAULLE
                  },
                  arrival: {
                    locationCode: 'JFK',
                    dateTime: new utils.DateTime(todayPlusNdays('13:50', 15)),
                    terminal: '1',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('17:50', 15)),
                    location: JOHN_F_KENNEDY_INTL
                  },
                  aircraftCode: '77W',
                  duration: 30_600,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: true,
                  meals: {
                    bookingClass: 'J',
                    mealCodes: [
                      'M',
                      'S'
                    ]
                  },
                  flightStatus: 'cancelled'
                },
                bookingStatus: {
                  name: 'Unable, does not operate'
                }
              }
            ],
            departure: {
              locationCode: 'NCE',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 0,
              destinationLocation: COTE_D_AZUR
            },
            arrival: {
              locationCode: 'JFK',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 11_400,
              destinationLocation: JOHN_F_KENNEDY_INTL
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 10_800
            },
            duration: 49_200,
            lostServices: [
              {
                descriptions: [
                  {
                    type: 'shortText',
                    content: 'SURF'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST2',
                targetFlightIds: [
                  'ST4'
                ],
                travelerIds: [
                  'PT1'
                ]
              }
            ],
            lostSeats: [
              {
                seatSelections: [
                  {
                    seatNumber: '3A',
                    travelerId: 'PT1'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST2',
                targetFlightIds: [
                  'ST4'
                ]
              }
            ],
            degradedSeats: [
              {
                seatId: 'OT15'
              }
            ]
          },
          originLocation: COTE_D_AZUR,
          destinationLocation: JOHN_F_KENNEDY_INTL,
          id: 'ST1:ST4',
          quota: 1.797_693_134_862_315_7e+308
        },
        {
          airBoundId: '2',
          originLocationCode: 'JFK',
          destinationLocationCode: 'NCE',
          flights: [
            {
              id: 'ST5',
              cabin: 'business',
              bookingClass: 'J',
              operating: {
                bookingClass: 'J'
              },
              statusCode: 'HK',
              arrivalDaysDifference: 1,
              flight: {
                marketingAirlineCode: 'AF',
                marketingAirline: 'AF',
                operatingAirlineCode: 'DL',
                marketingFlightNumber: '3593',
                operatingAirlineFlightNumber: '028',
                departure: {
                  locationCode: 'JFK',
                  dateTime: new utils.DateTime(todayPlusNdays('19:40', 25)),
                  terminal: '4',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('23:40', 25)),
                  location: JOHN_F_KENNEDY_INTL
                },
                arrival: {
                  locationCode: 'NCE',
                  dateTime: new utils.DateTime(todayPlusNdays('10:00', 26)),
                  terminal: '2',
                  dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('08:00', 26)),
                  location: COTE_D_AZUR
                },
                aircraftCode: '764',
                duration: 30_000,
                isOpenSegment: false,
                isInformational: false,
                secureFlightIndicator: true,
                meals: {
                  bookingClass: 'J',
                  mealCodes: [
                    'D'
                  ]
                },
                flightStatus: 'scheduled'
              },
              bookingStatus: {
                name: 'Holding confirmed'
              }
            }
          ],
          duration: 30_000,
          disruptionStatus: {
            originalFlights: [
              {
                id: 'ST3',
                cabin: 'business',
                bookingClass: 'J',
                operating: {
                  bookingClass: 'J'
                },
                statusCode: 'UN',
                arrivalDaysDifference: 1,
                flight: {
                  marketingAirlineCode: 'AF',
                  marketingAirline: 'AF',
                  operatingAirlineCode: 'DL',
                  marketingFlightNumber: '3588',
                  operatingAirlineFlightNumber: '047',
                  departure: {
                    locationCode: 'JFK',
                    dateTime: new utils.DateTime(todayPlusNdays('18:00', 25)),
                    terminal: '4',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('22:00', 25)),
                    location: JOHN_F_KENNEDY_INTL
                  },
                  arrival: {
                    locationCode: 'NCE',
                    dateTime: new utils.DateTime(todayPlusNdays('10:00', 26)),
                    terminal: '2',
                    dateTimeConsideringTimezone: new utils.DateTime(todayPlusNdays('06:20', 26)),
                    location: COTE_D_AZUR
                  },
                  aircraftCode: '764',
                  duration: 30_000,
                  isOpenSegment: false,
                  isInformational: false,
                  secureFlightIndicator: true,
                  meals: {
                    bookingClass: 'J',
                    mealCodes: [
                      'D'
                    ]
                  },
                  flightStatus: 'cancelled'
                },
                bookingStatus: {
                  name: 'cancelled'
                }
              }
            ],
            departure: {
              locationCode: 'JFK',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 11_400,
              destinationLocation: JOHN_F_KENNEDY_INTL
            },
            arrival: {
              locationCode: 'NCE',
              sameAirport: true,
              sameCity: true,
              sameDay: true,
              deltaTime: 0,
              destinationLocation: COTE_D_AZUR
            },
            connection: {
              status: 'ok',
              delta: 0,
              sameViaPoint: true,
              deltaTime: 10_800
            },
            duration: 30_000,
            lostServices: [
              {
                descriptions: [
                  {
                    type: 'shortText',
                    content: 'SURF'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST3',
                targetFlightIds: [
                  'ST5'
                ],
                travelerIds: [
                  'PT1'
                ]
              }
            ],
            lostSeats: [
              {
                seatSelections: [
                  {
                    seatNumber: '1A',
                    travelerId: 'PT1'
                  }
                ],
                isChargeable: true,
                originalFlightId: 'ST3',
                targetFlightIds: [
                  'ST5'
                ]
              }
            ],
            degradedSeats: [
              {
                seatId: 'OT70'
              }
            ]
          },
          originLocation: {
            ...JOHN_F_KENNEDY_INTL
          },
          destinationLocation: COTE_D_AZUR,
          id: 'ST5',
          quota: 1.797_693_134_862_315_7e+308
        }
      ]
    },
    services: [
      {
        id: 'OT9',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: createAmount({
                    template: {
                      value: 2500
                    }
                  }),
                  total: createAmount({
                    template: {
                      value: 2500
                    }
                  })
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: createAmount({
                template: {
                  value: 2500
                }
              }),
              total: createAmount({
                template: {
                  value: 2500
                }
              })
            }
          ]
        },
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT10',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT11',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0CC'
        },
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: createAmount({
                    template: {
                      value: 19_200
                    }
                  }),
                  total: createAmount({
                    template: {
                      value: 19_200
                    }
                  })
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: createAmount({
                template: {
                  value: 19_200
                }
              }),
              total: createAmount({
                template: {
                  value: 19_200
                }
              })
            }
          ]
        },
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT12',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0CC'
        },
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT13',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        reasonForIssuance: {
          code: 'G',
          subCode: '032'
        },
        quantity: 1,
        flightIds: [
          'ST1'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        prices: {
          unitPrices: [
            {
              prices: [
                {
                  base: createAmount({
                    template: {
                      value: 6000
                    }
                  }),
                  total: createAmount({
                    template: {
                      value: 6000
                    }
                  })
                }
              ]
            }
          ],
          totalPrices: [
            {
              base: createAmount({
                template: {
                  value: 6000
                }
              }),
              total: createAmount({
                template: {
                  value: 6000
                }
              })
            }
          ]
        },
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT14',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        reasonForIssuance: {
          code: 'G',
          subCode: '032'
        },
        quantity: 1,
        flightIds: [
          'ST2'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT73',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST4'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT74',
        descriptions: [
          {
            type: 'shortText',
            content: 'ABAG'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0CC'
        },
        quantity: 1,
        flightIds: [
          'ST4'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT75',
        descriptions: [
          {
            type: 'shortText',
            content: 'COLA'
          }
        ],
        reasonForIssuance: {
          code: 'G',
          subCode: '032'
        },
        quantity: 1,
        flightIds: [
          'ST4'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT76',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST3'
        ],
        statusCode: 'UN',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT77',
        descriptions: [
          {
            type: 'shortText',
            content: 'SURF'
          }
        ],
        reasonForIssuance: {
          code: 'C',
          subCode: '0GD'
        },
        quantity: 1,
        flightIds: [
          'ST5'
        ],
        statusCode: 'HK',
        travelerId: 'PT1',
        isChargeable: true,
        status: {
          name: 'Holding confirmed'
        }
      }
    ],
    seats: [
      {
        id: 'OT18',
        flightId: 'ST2',
        seatSelections: [
          {
            seatNumber: '3A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              },
              {
                code: 'W'
              },
              {
                code: 'A'
              },
              {
                code: 'K'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'UN',
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT15',
        flightId: 'ST1',
        seatSelections: [
          {
            seatNumber: '1A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              },
              {
                code: 'W'
              },
              {
                code: 'K'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'HK',
        status: {
          name: 'Holding confirmed'
        }
      },
      {
        id: 'OT70',
        flightId: 'ST4',
        seatSelections: [
          {
            seatNumber: '3A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              },
              {
                code: 'W'
              },
              {
                code: 'A'
              },
              {
                code: 'K'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'KK',
        status: {
          name: 'Confirmed'
        }
      },
      {
        id: 'OT21',
        flightId: 'ST3',
        seatSelections: [
          {
            seatNumber: '1A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'UN',
        status: {
          name: 'Unable, does not operate'
        }
      },
      {
        id: 'OT81',
        flightId: 'ST5',
        seatSelections: [
          {
            seatNumber: '1A',
            travelerId: 'PT1',
            seatCharacteristics: [
              {
                code: 'N'
              }
            ],
            isChargeable: false
          }
        ],
        statusCode: 'HK',
        status: {
          name: 'Holding confirmed'
        }
      }
    ],
    travelers: [
      createTraveler({
        template: {
          passengerTypeCode: 'ADT',
          id: 'PT1',
          names: [createName()]
        }
      })
    ],
    paymentRecords: [createPaymentRecord({
      template: {
        id: 'FPT41',
        travelerIds: [
          'PT1'
        ],
        flightIds: [
          'ST1'
        ],
        paymentTransactions: [
          {
            paymentMethod: createPaymentCard({
              template: {
                cardNumber: 'xxxxxxxxxxxx9999'
              }
            }),
            amount: createAmount({
              template: {
                value: 929_518
              }
            })
          }
        ]
      }
    })],
    contacts: [
      ...contacts
    ],
    orderEligibilities: createOrderEligibilities({
      template: {
        acknowledge: {
          ...acknowledgeMock
        },
        cancel: {
          ...cancelMock
        },
        cancelAndRefund: {
          ...cancelAndRefundMock
        },
        change: [...changeMock],
        flightReaccommodation: {
          acknowledge: [
          ],
          change: [
          ]
        }
      }
    })
  }
});

export const retrieveAcknowledgeConfirmationStatusError = {
  errors: [{
    code: '39408',
    title: 'ACKNOWLEDGE NOT ELIGIBLE',
    detail: 'Functionality is not enabled'
  }]
};

export const retrieveAcknowledgeConfirmationStatusSuccess = {
  warnings: [{
    code: '38126',
    title: 'UNABLE TO QUEUE',
    detail: 'No queue has been selected for PNR'
  }]
};
